import { clearCart } from '@/core/redux/cartSlice';
import { setActiveCustomerTab } from '@/core/redux/commonSlice';
import { RootState } from '@/core/redux/store';
import { postData } from '@/services/api.service';
import { getData } from '@/services/api.service';
import { end_points } from '@/services/endpoints';
import { email } from '@/utils/patterns/regex.pattern';
import { toast } from 'react-toastify';

import {
  addressPattern,
  alphabet,
  alphaNumericPattern,
  phoneNumber,
  UKPostalCode,
} from '@/utils/patterns/rgex';
import { routes } from '@/utils/routes/routes';
import { yupResolver } from '@hookform/resolvers/yup';
import { DevTool } from '@hookform/devtools';
import React, { useEffect, useState, useMemo, useRef } from 'react';
import { Controller, useForm, useWatch } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router';
import { loadStripe, Stripe } from '@stripe/stripe-js';
import * as yup from 'yup';
import StripeModal from '@/pages/Components/StripeModal';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import {
  addDays,
  isBefore,
  isSameDay,
  format,
  parseISO,
  differenceInDays,
  max,
} from 'date-fns';
import Spinner from './Components/spinner';
import PayPalModal from './Components/PayPalModal';

type CheckoutState = {
  quick: boolean;
};

export default function Checkout() {
  const hostname = window.location.hostname;
  const [loading, setLoading] = useState(false);
  const [paypalDetails, setPaypalDetails] = useState({});
  const [isPaypalModalOpen, setIsPaypalModalOpen] = useState(false);

  const [shipping, setShipping] = useState<boolean>(false);
  const [paymentGateway, setPaymentGateway] = useState('cod');
  // const [orderId, setOrderId] = useState();
  const [useExistingBillingAddress, setUseExistingBillingAddress] =
    useState(false);
  const [useExistingShippingAddress, setUseExistingShippingAddress] =
    useState(false);
  const [selectedBillingAddress, setSelectedBillingAddress] = useState(null);
  const [selectedShippingAddress, setSelectedShippingAddress] = useState(null);
  const cartItems = useSelector((state: RootState) => state.cart.cartItems);
  const [gateways, setGateways] = useState<any[]>([]);
  const [customerDetails, setCustomerDetails] = useState();
  const [address, setAddress] = useState([]);

  const location = useLocation();
  const state = location.state as CheckoutState;

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [serviceDate, setServiceDate] = useState(null);
  const [deliveryDate, setDeliveryDate] = useState(null);
  const [showStripeModal, setShowStripeModal] = useState(false);
  const [stripeDetails, setStripeDetails] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [publicHolidays, setPublicHolidays] = useState([]);
  const [deliveryHolidays, setDeliveryHolidays] = useState([]);
  const [deliveryHolidaysArray, setDeliveryHolidaysArray] = useState<any[]>([]);
  const [nextDeliveryDate, setNextDeliveryDate] = useState<string | null>(null);
  const [deliveryDatesLoaded, setDeliveryDatesLoaded] = useState(false);
  const [checkoutDetails, setCheckoutDetails] = useState<any>();
  const [deliveryTimeSlot, setDeliveryTimeSlot] = useState('');
  const [serviceTimeSlot, setServiceTimeSlot] = useState('');
  const [stripePromise, setStripePromise] = useState(null);
  const [shippingCost, setShippingCost] = useState(0);
  const [serviceType, setServiceType] = useState('pick_and_drop'); // 'pick_and_drop' or 'delivery'
  const [discounts, setDiscounts] = useState<any[]>([]);
  const [selectedDiscount, setSelectedDiscount] = useState<any>(null);
  const [deliveryServiceMode, setDeliveryServiceMode] = useState<number | null>(
    null
  );
  const [selectedDeliveryService, setSelectedDeliveryService] =
    useState<string>('');
  const [laundryServiceMode, setLaundryServiceMode] = useState<number | null>(
    null
  );
  const [selectedLaundryService, setSelectedLaundryService] =
    useState<string>('');
  const [restaurantServiceMode, setRestaurantServiceMode] = useState<
    number | null
  >(null);
  const [selectedRestaurantService, setSelectedRestaurantService] =
    useState<string>('');
  const [fieldServiceMode, setFieldServiceMode] = useState<number | null>(null);
  const [selectedFieldService, setSelectedFieldService] = useState<string>('');
  const [savedCards, setSavedCards] = useState<any[]>([]);
  const [selectedCard, setSelectedCard] = useState<any>(null);
  const [setupIntentClientSecret, setSetupIntentClientSecret] = useState<
    string | null
  >(null);
  const [useNewCard, setUseNewCard] = useState<boolean>(false);
  const [loadingSavedCards, setLoadingSavedCards] = useState<boolean>(false);
  const [isPlacingOrder, setIsPlacingOrder] = useState<boolean>(false);
  const isStripeSuccessRef = useRef<boolean>(false);
  const lastDeliveryChargeRequestKeyRef = useRef<string>('');
  const [coupons, setCoupons] = useState<any[]>([]);
  const [selectedCoupon, setSelectedCoupon] = useState<any>(null);
  const [couponCode, setCouponCode] = useState<string>('');
  const [couponError, setCouponError] = useState<string>('');
  const [isApplyingCoupon, setIsApplyingCoupon] = useState<boolean>(false);
  const [giftCards, setGiftCards] = useState<any[]>([]);
  const [selectedGiftCard, setSelectedGiftCard] = useState<any>(null);
  const [giftCardCode, setGiftCardCode] = useState<string>('');
  const [giftCardError, setGiftCardError] = useState<string>('');
  const [isApplyingGiftCard, setIsApplyingGiftCard] = useState<boolean>(false);

  useEffect(() => {
    if (cartItems?.length == 0 && !state) {
      toast.warn('Your cart is empty, please add products');
      navigate(routes.home);
    }
  }, []);

  useEffect(() => {
    if (checkoutDetails) {
      const stripe: any = loadStripe(
        checkoutDetails?.gateways?.find((gateway) => gateway?.name === 'Stripe')
          ?.key
      );
      setStripePromise(stripe);

      setShippingCost(10);
    }
  }, [checkoutDetails]);

  useEffect(() => {
    // Auto-select the only available gateway when COD is not available.
    if (!checkoutDetails?.is_cod && gateways.length === 1) {
      const onlyGatewayName = gateways[0]?.name;
      if (onlyGatewayName && paymentGateway !== onlyGatewayName) {
        setPaymentGateway(onlyGatewayName);
      }
    }
  }, [checkoutDetails?.is_cod, gateways, paymentGateway]);

  const currencyCode = useSelector(
    (state: RootState) => state.common.header?.currency?.code
  );

  const currencyId = useSelector(
    (state: RootState) => state.common.header?.currency?.id
  );

  const currencySymbol = useSelector(
    (state: RootState) => state.common.header?.currency?.symbol
  );

  const currentLocation = useSelector(
    (state: RootState) => state.currentLocation.currentLocation
  );

  const baseSubtotal = cartItems.reduce(
    (sum, item) => sum + item.price * item.quantity,
    0
  );

  // Calculate total quantity in cart
  const totalQuantity = cartItems.reduce(
    (sum, item) => sum + (item.quantity || 0),
    0
  );

  console.log('totalQuantity', totalQuantity);

  // Function to check if discount is applicable based on day
  const isDiscountApplicableToday = (discount: any) => {
    if (!discount?.days) return false;
    const today = new Date();
    const dayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const todayName = dayNames[today.getDay()];
    const applicableDays = discount.days.split(',').map((d) => d.trim());
    return applicableDays.includes(todayName);
  };
  console.log('selectedDiscount', selectedDiscount);

  // Auto-apply discount when "Drop off and collection" is selected for laundry service
  useEffect(() => {
    // Check if laundry service mode is active (check if laundryServiceMode is set)
    const isLaundryMode =
      laundryServiceMode !== null && laundryServiceMode !== undefined;
    const isLaundryDropOff =
      isLaundryMode && selectedLaundryService === 'drop_off_collection';

    if (isLaundryDropOff && discounts.length > 0 && checkoutDetails) {
      // Check for laundry_default_discount_id in checkout API response
      const laundryDefaultDiscountId = (checkoutDetails as any)
        ?.laundry_default_discount_id;

      if (laundryDefaultDiscountId) {
        // Find the discount with matching ID in discounts array
        const defaultDiscount = discounts.find(
          (discount: any) => discount.id === laundryDefaultDiscountId
        );

        if (defaultDiscount) {
          // Check if discount is applicable (day and quantity range).
          // `maximum_qty` is optional in the API response — when absent, treat
          // it as no upper bound.
          const isApplicable = isDiscountApplicableToday(defaultDiscount);
          const minQty = defaultDiscount.minimum_qty ?? 0;
          const maxQty = defaultDiscount.maximum_qty;
          const isInRange =
            totalQuantity >= minQty &&
            (maxQty == null || totalQuantity <= maxQty);

          // Auto-apply if applicable and different from current
          if (
            isApplicable &&
            isInRange &&
            selectedDiscount?.id !== defaultDiscount.id
          ) {
            setSelectedDiscount(defaultDiscount);
          } else if (
            (!isApplicable || !isInRange) &&
            selectedDiscount?.id === defaultDiscount.id
          ) {
            // Remove discount if no longer applicable
            setSelectedDiscount(null);
          }
        }
      } else {
        // If no laundry_default_discount_id, remove discount if it was auto-applied
        // Check if current discount matches any laundry default discount (if it exists)
        const laundryDefaultDiscountId = (checkoutDetails as any)
          ?.laundry_default_discount_id;
        if (
          laundryDefaultDiscountId &&
          selectedDiscount?.id === laundryDefaultDiscountId
        ) {
          setSelectedDiscount(null);
        }
      }
    } else if (isLaundryMode && selectedLaundryService === 'pickup_delivery') {
      // Remove discount when "Pickup and Delivery" is selected for laundry
      // Only remove if it was the laundry default discount
      const laundryDefaultDiscountId = (checkoutDetails as any)
        ?.laundry_default_discount_id;
      if (
        laundryDefaultDiscountId &&
        selectedDiscount?.id === laundryDefaultDiscountId
      ) {
        setSelectedDiscount(null);
      }
    } else if (!isLaundryDropOff && selectedDiscount && checkoutDetails) {
      // Remove discount if not in laundry drop off mode
      // Only remove if it was auto-applied (check if it matches laundry_default_discount_id)
      const laundryDefaultDiscountId = (checkoutDetails as any)
        ?.laundry_default_discount_id;
      if (
        laundryDefaultDiscountId &&
        selectedDiscount?.id === laundryDefaultDiscountId
      ) {
        setSelectedDiscount(null);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    selectedLaundryService,
    laundryServiceMode,
    discounts,
    checkoutDetails,
    totalQuantity,
  ]);

  // Function to calculate discount amount (pure function, no side effects)
  // For discount calculation, use baseSubtotal (not adjusted subtotal for quick orders)
  const calculateDiscount = useMemo(() => {
    if (!selectedDiscount || !isDiscountApplicableToday(selectedDiscount)) {
      return 0;
    }

    const { minimum_qty, maximum_qty, type, value } = selectedDiscount;

    // Check quantity range
    if (totalQuantity < minimum_qty || totalQuantity > maximum_qty) {
      return 0;
    }

    let discountAmount = 0;
    if (type === 'percentage') {
      // Use baseSubtotal for discount calculation, but apply to adjusted subtotal for quick orders
      discountAmount = (baseSubtotal * value) / 100;
    } else if (type === 'fixed') {
      discountAmount = value;
    }

    return discountAmount;
  }, [selectedDiscount, totalQuantity, baseSubtotal]);

  // Get minimum order amount from currentLocation
  const minimumOrderAmount = (currentLocation as any)?.minimum_order_amount
    ? parseFloat((currentLocation as any).minimum_order_amount)
    : 0;

  // For quick orders, if subtotal is less than minimum order amount, use minimum order amount as subtotal
  const subtotal =
    state?.quick && minimumOrderAmount > 0 && baseSubtotal < minimumOrderAmount
      ? minimumOrderAmount
      : baseSubtotal;

  // Get the key that controls whether discount affects minimum order amount
  // 0 = apply minimum amount if discount total < minimum (current behavior)
  // 1 = ignore minimum amount and use discount total if discount total < minimum
  const discountAffectsMinimum =
    (currentLocation as any)?.discount_affects_minimum !== undefined
      ? parseInt((currentLocation as any).discount_affects_minimum)
      : 0;

  // Function to calculate coupon discount
  // Coupon is applied on subtotal after discount
  const calculateCouponDiscount = useMemo(() => {
    if (!selectedCoupon) {
      return 0;
    }

    const { type, amount, minimum_amount, expired_date, quantity, used } =
      selectedCoupon;

    // Check if coupon is expired
    if (expired_date) {
      const expiryDate = parseISO(expired_date);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      if (isBefore(expiryDate, today)) {
        return 0;
      }
    }

    // Check if coupon usage limit is reached
    if (quantity && used >= quantity) {
      return 0;
    }

    // Calculate subtotal after discount for coupon calculation
    const subtotalAfterDiscount = subtotal - calculateDiscount;

    // Check minimum amount requirement (on subtotal after discount)
    if (minimum_amount && subtotalAfterDiscount < minimum_amount) {
      return 0;
    }

    let couponDiscount = 0;
    if (type === 'percentage') {
      // Apply coupon on subtotal after discount
      couponDiscount = (subtotalAfterDiscount * amount) / 100;
    } else if (type === 'fixed') {
      couponDiscount = amount;
    }

    // If discountAffectsMinimum is 0, limit coupon discount so it doesn't reduce below minimum order amount
    if (discountAffectsMinimum === 0 && minimumOrderAmount > 0) {
      // Calculate service cost for minimum check
      let serviceCostForMinCheck = 0;
      if (currentLocation) {
        const pickAndDropCost = parseFloat(currentLocation.shipping_cost) || 0;
        const deliveryCost = parseFloat(currentLocation.delivery_cost) || 0;
        const bothHaveCosts = pickAndDropCost > 0 && deliveryCost > 0;

        if (bothHaveCosts) {
          if (serviceType === 'pick_and_drop') {
            serviceCostForMinCheck = pickAndDropCost;
          } else if (serviceType === 'delivery') {
            serviceCostForMinCheck = deliveryCost;
          }
        } else {
          if (pickAndDropCost > 0) {
            serviceCostForMinCheck = pickAndDropCost;
          } else if (deliveryCost > 0) {
            serviceCostForMinCheck = deliveryCost;
          }
        }
      }

      // Calculate total after discount and coupon
      const totalAfterDiscountAndCoupon =
        subtotalAfterDiscount - couponDiscount + serviceCostForMinCheck;

      // If total would be below minimum, cap the coupon discount
      if (totalAfterDiscountAndCoupon < minimumOrderAmount) {
        // Maximum allowed coupon discount = subtotalAfterDiscount + serviceCost - minimumOrderAmount
        const maxAllowedCouponDiscount =
          subtotalAfterDiscount + serviceCostForMinCheck - minimumOrderAmount;
        if (maxAllowedCouponDiscount > 0) {
          couponDiscount = Math.min(couponDiscount, maxAllowedCouponDiscount);
        } else {
          // If even without coupon we're below minimum, don't apply coupon discount
          couponDiscount = 0;
        }
      }
    }

    return couponDiscount;
  }, [
    selectedCoupon,
    subtotal,
    calculateDiscount,
    discountAffectsMinimum,
    minimumOrderAmount,
    currentLocation,
    serviceType,
  ]);

  // Function to apply coupon
  const handleApplyCoupon = () => {
    setCouponError('');
    setIsApplyingCoupon(true);

    if (!couponCode.trim()) {
      setCouponError('Please enter a coupon code');
      setIsApplyingCoupon(false);
      return;
    }

    // Find coupon by code
    const coupon = coupons.find(
      (c) => c.code.toLowerCase() === couponCode.trim().toLowerCase()
    );

    if (!coupon) {
      setCouponError('Invalid coupon code');
      setIsApplyingCoupon(false);
      return;
    }

    // Check if coupon is active
    if (!coupon.is_active) {
      setCouponError('This coupon is not active');
      setIsApplyingCoupon(false);
      return;
    }

    // Check if coupon is expired
    if (coupon.expired_date) {
      const expiryDate = parseISO(coupon.expired_date);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      if (isBefore(expiryDate, today)) {
        setCouponError('This coupon has expired');
        setIsApplyingCoupon(false);
        return;
      }
    }

    // Check if coupon usage limit is reached
    if (coupon.quantity && coupon.used >= coupon.quantity) {
      setCouponError('This coupon is out of stock');
      setIsApplyingCoupon(false);
      return;
    }

    // Check minimum amount requirement (on subtotal after discount)
    const subtotalAfterDiscount = subtotal - calculateDiscount;
    if (
      coupon.minimum_amount &&
      subtotalAfterDiscount < coupon.minimum_amount
    ) {
      setCouponError(
        `Minimum order amount of ${currencySymbol}${coupon.minimum_amount} required`
      );
      setIsApplyingCoupon(false);
      return;
    }

    // Apply coupon
    setSelectedCoupon(coupon);
    toast.success('Coupon applied successfully!');
    setIsApplyingCoupon(false);
  };

  // Function to remove coupon
  const handleRemoveCoupon = () => {
    setSelectedCoupon(null);
    setCouponCode('');
    setCouponError('');
    toast.info('Coupon removed');
  };

  // Function to calculate gift card available balance
  const giftCardAvailableBalance = useMemo(() => {
    if (!selectedGiftCard) {
      return 0;
    }

    const { amount, expired_date, is_active } = selectedGiftCard;

    // Check if gift card is active
    if (!is_active) {
      return 0;
    }

    // Check if gift card is expired
    if (expired_date) {
      const expiryDate = parseISO(expired_date);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      if (isBefore(expiryDate, today)) {
        return 0;
      }
    }

    // Use amount directly without subtracting expense
    const availableBalance = parseFloat(amount) || 0;

    return availableBalance > 0 ? availableBalance : 0;
  }, [selectedGiftCard]);

  // Function to apply gift card
  const handleApplyGiftCard = () => {
    setGiftCardError('');
    setIsApplyingGiftCard(true);

    if (!giftCardCode.trim()) {
      setGiftCardError('Please enter a gift card number');
      setIsApplyingGiftCard(false);
      return;
    }

    // Find gift card by card number
    const giftCard = giftCards.find((gc) => gc.card_no === giftCardCode.trim());

    if (!giftCard) {
      setGiftCardError('Invalid gift card number');
      setIsApplyingGiftCard(false);
      return;
    }

    // Check if gift card is active
    if (!giftCard.is_active) {
      setGiftCardError('This gift card is not active');
      setIsApplyingGiftCard(false);
      return;
    }

    // Check if gift card is expired
    if (giftCard.expired_date) {
      const expiryDate = parseISO(giftCard.expired_date);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      if (isBefore(expiryDate, today)) {
        setGiftCardError('This gift card has expired');
        setIsApplyingGiftCard(false);
        return;
      }
    }

    // Check available balance (use amount directly, don't subtract expense)
    const availableBalance = parseFloat(giftCard.amount) || 0;
    if (availableBalance <= 0) {
      setGiftCardError('This gift card has no available balance');
      setIsApplyingGiftCard(false);
      return;
    }

    // Apply gift card
    setSelectedGiftCard(giftCard);
    toast.success('Gift card applied successfully!');
    setIsApplyingGiftCard(false);
  };

  // Function to remove gift card
  const handleRemoveGiftCard = () => {
    setSelectedGiftCard(null);
    setGiftCardCode('');
    setGiftCardError('');
    toast.info('Gift card removed');
  };

  // Helper function to calculate total before gift card (to avoid circular dependency)
  const getTotalBeforeGiftCard = useMemo(() => {
    const baseTotal = subtotal;
    let serviceCost = 0;

    if (currentLocation) {
      const pickAndDropCost = parseFloat(currentLocation.shipping_cost) || 0;
      const deliveryCost = parseFloat(currentLocation.delivery_cost) || 0;
      const bothHaveCosts = pickAndDropCost > 0 && deliveryCost > 0;

      if (bothHaveCosts) {
        if (serviceType === 'pick_and_drop') {
          serviceCost = pickAndDropCost;
        } else if (serviceType === 'delivery') {
          serviceCost = deliveryCost;
        }
      } else {
        if (pickAndDropCost > 0) {
          serviceCost = pickAndDropCost;
        } else if (deliveryCost > 0) {
          serviceCost = deliveryCost;
        }
      }
    }

    const totalBeforeDiscount = baseTotal + serviceCost;
    const calculatedTotal =
      totalBeforeDiscount - calculateDiscount - calculateCouponDiscount;

    const isAtMinimumStage =
      minimumOrderAmount > 0 && totalBeforeDiscount < minimumOrderAmount;

    if (isAtMinimumStage && discountAffectsMinimum === 0) {
      return minimumOrderAmount;
    }

    if (minimumOrderAmount > 0 && calculatedTotal < minimumOrderAmount) {
      if (discountAffectsMinimum === 0) {
        return minimumOrderAmount;
      } else if (discountAffectsMinimum === 1) {
        return calculatedTotal;
      }
    }

    return calculatedTotal;
  }, [
    subtotal,
    calculateDiscount,
    calculateCouponDiscount,
    minimumOrderAmount,
    discountAffectsMinimum,
    currentLocation,
    serviceType,
  ]);

  // Calculate actual gift card amount to use (min of available balance and total before gift card)
  const giftCardAmountToUse = useMemo(() => {
    if (!selectedGiftCard || giftCardAvailableBalance <= 0) {
      return 0;
    }
    return Math.min(giftCardAvailableBalance, getTotalBeforeGiftCard);
  }, [selectedGiftCard, giftCardAvailableBalance, getTotalBeforeGiftCard]);

  // Calculate remaining amount after gift card
  const remainingAfterGiftCard = useMemo(() => {
    return Math.max(0, getTotalBeforeGiftCard - giftCardAmountToUse);
  }, [giftCardAmountToUse, getTotalBeforeGiftCard]);

  // Check if gift card covers full amount
  const isGiftCardFullPayment = useMemo(() => {
    return (
      giftCardAmountToUse >= getTotalBeforeGiftCard &&
      getTotalBeforeGiftCard > 0
    );
  }, [giftCardAmountToUse, getTotalBeforeGiftCard]);

  // Auto-select gift_card payment gateway when gift card covers full payment
  useEffect(() => {
    if (isGiftCardFullPayment && paymentGateway !== 'gift_card') {
      setPaymentGateway('gift_card');
    } else if (!isGiftCardFullPayment && paymentGateway === 'gift_card') {
      // If gift card no longer covers full payment, switch back to COD
      setPaymentGateway('cod');
    }
  }, [isGiftCardFullPayment]);

  // Calculate subtotal after discount and coupon for minimum order check
  const subtotalAfterDiscount =
    subtotal - calculateDiscount - calculateCouponDiscount;

  // Calculate service cost for minimum order check
  let serviceCostForMinCheck = 0;
  if (currentLocation) {
    const pickAndDropCost = parseFloat(currentLocation.shipping_cost) || 0;
    const deliveryCost = parseFloat(currentLocation.delivery_cost) || 0;
    const bothHaveCosts = pickAndDropCost > 0 && deliveryCost > 0;

    if (bothHaveCosts) {
      if (serviceType === 'pick_and_drop') {
        serviceCostForMinCheck = pickAndDropCost;
      } else if (serviceType === 'delivery') {
        serviceCostForMinCheck = deliveryCost;
      }
    } else {
      if (pickAndDropCost > 0) {
        serviceCostForMinCheck = pickAndDropCost;
      } else if (deliveryCost > 0) {
        serviceCostForMinCheck = deliveryCost;
      }
    }
  }

  // Check if minimum order amount is met (check against subtotal after discount + service cost)
  const totalForMinCheck = subtotalAfterDiscount + serviceCostForMinCheck;

  // If discountAffectsMinimum is 1, we ignore minimum order requirement when discount or coupon is applied
  // Check minimum only if discountAffectsMinimum is 0 OR if neither discount nor coupon is applied
  const shouldCheckMinimum =
    discountAffectsMinimum === 0 ||
    (calculateDiscount === 0 && calculateCouponDiscount === 0);
  const isMinimumOrderMet =
    minimumOrderAmount === 0 ||
    !shouldCheckMinimum ||
    totalForMinCheck >= minimumOrderAmount;

  // Calculate remaining amount: if subtotal (before discount) is less than minimum,
  // calculate remaining without subtracting discount
  const totalBeforeDiscount = subtotal + serviceCostForMinCheck;
  const remainingAmountCalc = minimumOrderAmount - totalBeforeDiscount;
  const remainingAmount =
    minimumOrderAmount > 0 &&
    !isMinimumOrderMet &&
    shouldCheckMinimum &&
    remainingAmountCalc > 0
      ? remainingAmountCalc.toFixed(2)
      : 0;

  const total = () => {
    const baseTotal = subtotal;
    let serviceCost = 0;

    if (currentLocation) {
      const pickAndDropCost = parseFloat(currentLocation.shipping_cost) || 0;
      const deliveryCost = parseFloat(currentLocation.delivery_cost) || 0;

      // Check if both services have costs
      const bothHaveCosts = pickAndDropCost > 0 && deliveryCost > 0;

      if (bothHaveCosts) {
        // Show radio buttons - user selects service type
        if (serviceType === 'pick_and_drop') {
          serviceCost = pickAndDropCost;
        } else if (serviceType === 'delivery') {
          serviceCost = deliveryCost;
        }
      } else {
        // Only one service has cost - add it automatically
        if (pickAndDropCost > 0) {
          serviceCost = pickAndDropCost;
        } else if (deliveryCost > 0) {
          serviceCost = deliveryCost;
        }
      }
    }

    const totalBeforeDiscount = baseTotal + serviceCost;
    const calculatedTotal =
      totalBeforeDiscount - calculateDiscount - calculateCouponDiscount;

    // SIMPLIFIED LOGIC: Match cart.tsx behavior - always apply minimum when total < minimum
    // Exception: Only skip minimum if discountAffectsMinimum === 1 AND discounts/coupons are actually applied

    // First, check if we need to apply minimum order amount
    if (minimumOrderAmount > 0) {
      // Check if total before discount is less than minimum
      if (totalBeforeDiscount < minimumOrderAmount) {
        // Only skip minimum if discountAffectsMinimum is 1 AND discounts/coupons are applied
        if (
          discountAffectsMinimum === 1 &&
          (calculateDiscount > 0 || calculateCouponDiscount > 0)
        ) {
          // Use calculated total (ignore minimum)
          const finalTotal = calculatedTotal - giftCardAmountToUse;
          return Math.max(0, finalTotal);
        }
        // Otherwise, always apply minimum (same as cart.tsx)
        const finalTotal = minimumOrderAmount - giftCardAmountToUse;
        return Math.max(0, finalTotal);
      }

      // If total before discount >= minimum, but calculated total (after discounts) < minimum
      if (calculatedTotal < minimumOrderAmount) {
        // Only apply minimum if discountAffectsMinimum is 0
        if (discountAffectsMinimum === 0) {
          const finalTotal = minimumOrderAmount - giftCardAmountToUse;
          return Math.max(0, finalTotal);
        } else if (discountAffectsMinimum === 1) {
          // Use calculated total (ignore minimum)
          const finalTotal = calculatedTotal - giftCardAmountToUse;
          return Math.max(0, finalTotal);
        }
      }
    }

    // Apply gift card discount
    const finalTotal = calculatedTotal - giftCardAmountToUse;
    return Math.max(0, finalTotal);
  };

  // Helper function to check if both services have costs
  const shouldShowServiceTypeSelection = () => {
    if (!currentLocation) return false;
    const pickAndDropCost = parseFloat(currentLocation.shipping_cost) || 0;
    const deliveryCost = parseFloat(currentLocation.delivery_cost) || 0;
    return pickAndDropCost > 0 && deliveryCost > 0;
    111111;
  };

  // Helper function to determine which service mode to show
  const getServiceModeToShow = () => {
    // PRIORITY 1: Get product type from cart items first (each product has a "type" key)
    // Check all cart items to find the product type
    let productType: string | undefined;
    if (cartItems && cartItems.length > 0) {
      // Check each cart item for the "type" field
      for (const item of cartItems) {
        const itemType = (item as any)?.type;
        if (
          itemType === 'food' ||
          itemType === 'Food' ||
          itemType === 'service' ||
          itemType === 'Service'
        ) {
          productType = itemType;
          break; // Use the first matching type found
        }
      }
    }

    // Fallback: Get product type from checkout API response if not found in cart items
    if (!productType) {
      productType =
        (checkoutDetails as any)?.product_type ||
        (checkoutDetails as any)?.productType ||
        (checkoutDetails as any)?.type;
    }

    // Get service_mode from cart items (check if any item has service_mode = 2)
    const hasServiceMode2 = cartItems?.some(
      (item) => item?.service_mode === '2'
    );
    const hasServiceMode1 =
      cartItems?.some((item) => item?.service_mode === '1') || !hasServiceMode2;

    // Condition 1: If product type is "food" → show restaurant service modes
    // Check restaurant_service_mode directly from API response
    if (productType === 'food' || productType === 'Food') {
      const restaurantMode =
        restaurantServiceMode ??
        (checkoutDetails as any)?.restaurant_service_mode;
      if (restaurantMode !== null && restaurantMode !== undefined) {
        return {
          type: 'restaurant',
          mode: restaurantMode,
          selected: selectedRestaurantService,
          setSelected: setSelectedRestaurantService,
        };
      }
      // If restaurant_service_mode is not available, don't show anything (don't fall through to field service)
      return null;
    }

    // Condition 2: If product type is "service" → check service_mode
    if (productType === 'service' || productType === 'Service') {
      // If service_mode is 1 → show appointment modes (field_service_mode)
      if (hasServiceMode1 && !hasServiceMode2) {
        const fieldMode =
          fieldServiceMode ?? (checkoutDetails as any)?.field_service_mode;
        if (fieldMode !== null && fieldMode !== undefined) {
          return {
            type: 'field',
            mode: fieldMode,
            selected: selectedFieldService,
            setSelected: setSelectedFieldService,
          };
        }
      }

      // If service_mode is 2 → show laundry modes (drop off, pickup delivery)
      if (hasServiceMode2) {
        const laundryMode =
          laundryServiceMode ?? (checkoutDetails as any)?.laundry_service_mode;
        if (laundryMode !== null && laundryMode !== undefined) {
          return {
            type: 'laundry',
            mode: laundryMode,
            selected: selectedLaundryService,
            setSelected: setSelectedLaundryService,
          };
        }
      }
    }

    // Fallback: If product type is not detected, check service_mode
    // If service_mode is 2 → show laundry modes
    if (hasServiceMode2) {
      const laundryMode =
        laundryServiceMode ?? (checkoutDetails as any)?.laundry_service_mode;
      if (laundryMode !== null && laundryMode !== undefined) {
        return {
          type: 'laundry',
          mode: laundryMode,
          selected: selectedLaundryService,
          setSelected: setSelectedLaundryService,
        };
      }
    }

    // Fallback: If service_mode is 1 or unknown → show field service modes (only if product type is not "food")
    if (productType !== 'food' && productType !== 'Food') {
      const fieldMode =
        fieldServiceMode ?? (checkoutDetails as any)?.field_service_mode;
      if (fieldMode !== null && fieldMode !== undefined) {
        return {
          type: 'field',
          mode: fieldMode,
          selected: selectedFieldService,
          setSelected: setSelectedFieldService,
        };
      }
    }

    return null;
  };

  // Helper function to get the automatic service cost (when only one service has cost)
  const getAutomaticServiceCost = () => {
    if (!currentLocation) return { cost: 0, type: '' };
    const pickAndDropCost =
      parseFloat(String(currentLocation.shipping_cost || 0)) || 0;
    const deliveryCost =
      parseFloat(String(currentLocation.delivery_cost || 0)) || 0;

    if (pickAndDropCost > 0 && deliveryCost === 0) {
      return { cost: pickAndDropCost, type: 'Pick and Drop' };
    } else if (deliveryCost > 0 && pickAndDropCost === 0) {
      return { cost: deliveryCost, type: 'Delivery' };
    }
    return { cost: 0, type: '' };
  };

  const getAddress = async () => {
    setLoading(true);
    try {
      const response = await getData(end_points.address.url);
      setAddress(response?.data?.addresses);
      if (response?.data?.addresses?.length > 0) {
        setUseExistingBillingAddress(true);
        setSelectedBillingAddress(response?.data?.addresses[0]);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const generateHolidayDates = (holidayArray) => {
    const allDates = [];

    holidayArray.forEach(({ from_date, to_date }) => {
      const start = parseISO(from_date);
      const end = parseISO(to_date);
      const daysDiff = differenceInDays(end, start);

      for (let i = 0; i <= daysDiff; i++) {
        const date = addDays(start, i);
        allDates.push(format(date, 'yyyy-MM-dd'));
      }
    });

    setPublicHolidays(allDates);
  };

  const generateDeliveryHolidayDates = (holidayArray) => {
    const allDates = [];

    // Store the original holidays array to get the last to_date
    setDeliveryHolidaysArray(holidayArray);

    holidayArray.forEach(({ from_date, to_date }) => {
      const start = parseISO(from_date);
      const end = parseISO(to_date);
      const daysDiff = differenceInDays(end, start);

      for (let i = 0; i <= daysDiff; i++) {
        const date = addDays(start, i);
        allDates.push(format(date, 'yyyy-MM-dd'));
      }
    });

    setDeliveryHolidays(allDates);
  };

  // const payload = localStorage.getItem('cart');
  // const processPayload = JSON.parse(payload || '[]');
  // const cartItemsForPost = Array.isArray(processPayload)
  //   ? processPayload
  //   : Array.isArray(processPayload?.cart)
  //     ? processPayload.cart
  //     : [];

  // console.log(cartItemsForPost);
  // const data = cartItemsForPost.map((item: any) => ({
  //   id: item.id,
  //   name: item.name,
  //   unit_price: item.price,
  //   image: item.image,
  //   category_id: item.category_id,
  //   qty: item.quantity,
  //   variant: item.variant,
  //   service_mode: item.service_mode,
  // }));
  // console.log(data);

  // const postCart = async () => {
  //   try {
  //     const response = await postData(end_points.checkout.url, { cart: data });
  //     console.log(response);
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  const getCheckoutDetails = async () => {
    try {
      const hasServiceMode2 = cartItems?.some(
        (item) => item?.service_mode === '2'
      );

      const response = await getData(
        `${end_points.checkout.url}?service_mode=${hasServiceMode2 ? 2 : 1}`
        /* { cart: data } */
      );
      setCheckoutDetails(response?.data);
      setGateways(response.data.gateways);
      setCustomerDetails(response?.data?.customer_data?.customer);
      generateHolidayDates(response?.data?.holidays);
      // Extract discounts from response
      if (response?.data?.discounts && Array.isArray(response.data.discounts)) {
        setDiscounts(response.data.discounts);
      }
      // Extract coupons from response
      if (response?.data?.coupons && Array.isArray(response.data.coupons)) {
        setCoupons(response.data.coupons);
      }
      // Extract gift cards from response
      if (
        response?.data?.gift_cards &&
        Array.isArray(response.data.gift_cards)
      ) {
        setGiftCards(response.data.gift_cards);
      }
      // Extract laundry_service_mode from response (for service_mode = 2)
      if (
        response?.data?.laundry_service_mode !== null &&
        response?.data?.laundry_service_mode !== undefined
      ) {
        // API may return this as either a number or a numeric string ("1"),
        // so normalize before comparing.
        const laundryMode = Number(response.data.laundry_service_mode);
        setLaundryServiceMode(laundryMode);
        // Set default selection based on mode
        if (laundryMode === 1) {
          setSelectedLaundryService('drop_off_collection');
        } else if (laundryMode === 2) {
          setSelectedLaundryService('pickup_delivery');
        } else if (laundryMode === 3) {
          // Default to first option when both are available
          setSelectedLaundryService('drop_off_collection');
        }
      }

      // Extract restaurant_service_mode from response (for service_mode = 1 and product type = food)
      if (
        response?.data?.restaurant_service_mode !== null &&
        response?.data?.restaurant_service_mode !== undefined
      ) {
        setRestaurantServiceMode(response.data.restaurant_service_mode);
        // Set default selection based on mode
        if (response.data.restaurant_service_mode === 1) {
          setSelectedRestaurantService('dine_in');
        } else if (response.data.restaurant_service_mode === 2) {
          setSelectedRestaurantService('takeaway');
        } else if (response.data.restaurant_service_mode === 3) {
          setSelectedRestaurantService('delivery');
        } else if (response.data.restaurant_service_mode === 4) {
          // Default to first option when all are available
          setSelectedRestaurantService('dine_in');
        }
      }

      // Extract field_service_mode from response (for service_mode = 1 and product type = service)
      if (
        response?.data?.field_service_mode !== null &&
        response?.data?.field_service_mode !== undefined
      ) {
        setFieldServiceMode(response.data.field_service_mode);
        // Set default selection based on mode
        if (response.data.field_service_mode === 1) {
          setSelectedFieldService('in_store_appointment');
        } else if (response.data.field_service_mode === 2) {
          setSelectedFieldService('on_site_appointment');
        } else if (response.data.field_service_mode === 3) {
          // Default to first option when both are available
          setSelectedFieldService('in_store_appointment');
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getDeliveryDates = async (selectedDate?: Date | null) => {
    try {
      // Block delivery dates before API call
      setDeliveryDatesLoaded(false);
      console.log('getDeliveryDates called with date:', selectedDate);

      // Use the provided date or fall back to serviceDate state
      const dateToUse = selectedDate || serviceDate;

      // Extract process_time values from cart items and find the maximum
      const processTimeArray = cartItems
        .map((item: any) => item?.process_time)
        .filter((time) => time !== undefined && time !== null && time > 0)
        .map((time) => Number(time));

      if (processTimeArray.length === 0) {
        // Pass 1 hrs default process time
        processTimeArray.push(1);
      }

      const maxProcessTime = Math.max(...processTimeArray);
      console.log('Max process_time:', maxProcessTime);

      // Get shop_id from localStorage
      const shopId = currentLocation?.id || 1;

      // Check if service_date is set
      if (!dateToUse) {
        console.log('service_date is not set');
        return;
      }

      // Format service_date as yyyy-MM-dd
      const formattedServiceDate = format(dateToUse, 'yyyy-MM-dd');
      console.log('Calling get_delivery_dates API with:', {
        service_date: formattedServiceDate,
        process_time: maxProcessTime,
        shop_id: shopId,
      });

      // Call the POST API with payload
      const payload = {
        service_date: formattedServiceDate,
        process_time: maxProcessTime,
        shop_id: shopId,
      };

      const response = await postData(end_points.getDeliveryDates.url, payload);

      if (response?.status === 200 || response?.status === 201) {
        console.log('Delivery dates response:', response?.data);

        // Process holidays array from response (check both response.data.holidays and response.data.data.holidays)
        const holidays =
          response?.data?.data?.holidays || response?.data?.holidays;
        if (holidays && Array.isArray(holidays)) {
          generateDeliveryHolidayDates(holidays);
        }

        // Set next_delivery_date from response (check both response.data.data.next_delivery_date and response.data.next_delivery_date)
        // Also handle typo in API response: "next_delivery_date" (with space)
        const nextDeliveryDateValue = response?.data?.data?.next_delivery_date;

        if (nextDeliveryDateValue) {
          setNextDeliveryDate(nextDeliveryDateValue);
          // Set the delivery date to next_delivery_date as initial value
          let nextDate = parseISO(nextDeliveryDateValue);

          // Check if next_delivery_date is a holiday by checking the holidays array directly
          // Generate a temporary set of holiday dates to check
          const tempHolidayDates: string[] = [];
          if (holidays && Array.isArray(holidays)) {
            holidays.forEach(({ from_date, to_date }) => {
              const start = parseISO(from_date);
              const end = parseISO(to_date);
              const daysDiff = differenceInDays(end, start);
              for (let i = 0; i <= daysDiff; i++) {
                const date = addDays(start, i);
                tempHolidayDates.push(format(date, 'yyyy-MM-dd'));
              }
            });
          }

          const nextDateFormatted = format(nextDate, 'yyyy-MM-dd');
          // Check if next_delivery_date is a holiday, if yes then find next valid date
          if (tempHolidayDates.includes(nextDateFormatted)) {
            // Find next valid date that is not a holiday and not before today
            let validDate: Date | null = new Date(nextDate);
            const maxDate = getLastDeliveryToDate();
            let found = false;
            let attempts = 0;
            const maxAttempts = 365; // Prevent infinite loop

            while (!found && validDate && attempts < maxAttempts) {
              validDate = addDays(validDate, 1);
              attempts++;

              // Stop if we exceed the max date
              if (maxDate && isBefore(maxDate, validDate)) {
                validDate = null;
                break;
              }

              if (validDate) {
                const validDateFormatted = format(validDate, 'yyyy-MM-dd');
                // Check if date is not a holiday and not before today
                if (
                  !tempHolidayDates.includes(validDateFormatted) &&
                  !isBefore(validDate, today)
                ) {
                  found = true;
                }
              }
            }

            if (validDate && found) {
              nextDate = validDate;
              console.log(
                'next_delivery_date was a holiday, using next valid date:',
                format(validDate, 'yyyy-MM-dd')
              );
            } else {
              console.warn(
                'No valid delivery date found after next_delivery_date'
              );
            }
          }

          setDeliveryDate(nextDate);
          billingFormSetValue('deliveryDate', nextDate);
        }

        // Enable delivery dates after API call completes successfully
        setDeliveryDatesLoaded(true);
      }
    } catch (error) {
      console.error('Error fetching delivery dates:', error);
      // Keep delivery dates blocked on error
      setDeliveryDatesLoaded(false);
    }
  };

  useEffect(() => {
    getAddress();
    getCheckoutDetails();
    // postCart();
  }, []);

  // Fetch saved cards
  const fetchSavedCards = async () => {
    try {
      setLoadingSavedCards(true);
      const response = await getData(end_points.listSavedCards.url);
      if (response?.data?.data && Array.isArray(response.data.data)) {
        setSavedCards(response.data.data);
      } else {
        setSavedCards([]);
      }
    } catch (error) {
      console.error('Error fetching saved cards:', error);
      setSavedCards([]);
    } finally {
      setLoadingSavedCards(false);
    }
  };

  // Create setup intent for saving new card
  const createSetupIntent = async () => {
    try {
      const response = await postData(end_points.createSetupIntent.url, {});
      console.log('Setup Intent Response:', response); // Debug log

      // API response structure: { success: true, data: { intent_client_secret: "..." } }
      if (response?.data?.data?.intent_client_secret) {
        const clientSecret = response.data.data.intent_client_secret;
        setSetupIntentClientSecret(clientSecret);
        return clientSecret;
      } else {
        console.error('Setup Intent Response Structure:', response?.data);
        toast.error('Failed to get setup intent from server');
        return null;
      }
    } catch (error) {
      console.error('Error creating setup intent:', error);
      toast.error('Failed to initialize card setup');
      return null;
    }
  };

  // Fetch saved cards when Stripe is selected
  useEffect(() => {
    if (paymentGateway.toLowerCase() === 'stripe') {
      fetchSavedCards();
    }
  }, [paymentGateway]);

  const isHoliday = (date) => {
    const formatted = format(date, 'yyyy-MM-dd');
    return publicHolidays.includes(formatted);
  };

  const isDeliveryHoliday = (date) => {
    const formatted = format(date, 'yyyy-MM-dd');
    return deliveryHolidays.includes(formatted);
  };

  const getNextValidDate = (startDate) => {
    let nextDate = new Date(startDate);
    do {
      nextDate = addDays(nextDate, 1);
    } while (isHoliday(nextDate));
    return nextDate;
  };

  const getNextValidDeliveryDate = (startDate) => {
    let nextDate = new Date(startDate);
    const maxDate = getLastDeliveryToDate();
    do {
      nextDate = addDays(nextDate, 1);
      // Stop if we exceed the max date
      if (maxDate && isBefore(maxDate, nextDate)) {
        return null; // No valid date found
      }
    } while (isDeliveryHoliday(nextDate) || isBefore(nextDate, today));
    return nextDate;
  };

  const today = new Date();

  const isDateSelectable = (date) => {
    return !isBefore(date, today) && !isHoliday(date);
  };

  const isDeliveryDateSelectable = (date) => {
    // Disable dates that are before today or are delivery holidays
    if (isBefore(date, today)) {
      return false;
    }
    if (isDeliveryHoliday(date)) {
      return false;
    }

    // Get the last to_date from deliveryHolidaysArray to set maxDate
    if (deliveryHolidaysArray.length > 0) {
      const lastToDate = deliveryHolidaysArray.reduce((max, holiday) => {
        const holidayToDate = parseISO(holiday.to_date);
        const maxDate = parseISO(max.to_date);
        return holidayToDate > maxDate ? holiday : max;
      }, deliveryHolidaysArray[0]);

      const maxDate = parseISO(lastToDate.to_date);
      // Disable dates after the last to_date
      if (isBefore(maxDate, date)) {
        return false;
      }
    }

    return true;
  };

  // Get the last to_date for maxDate
  const getLastDeliveryToDate = () => {
    if (deliveryHolidaysArray.length > 0) {
      const lastToDate = deliveryHolidaysArray.reduce((max, holiday) => {
        const holidayToDate = parseISO(holiday.to_date);
        const maxDate = parseISO(max.to_date);
        return holidayToDate > maxDate ? holiday : max;
      }, deliveryHolidaysArray[0]);

      return parseISO(lastToDate.to_date);
    }
    return undefined;
  };

  const FormSchema = yup.object({
    serviceDate: yup
      .date()
      .nullable()
      .when('service_required', {
        is: true,
        then: (schema) => schema.required('Service date is required'),
      }),

    serviceTimeSlot: yup.string().nullable(),

    deliveryDate: yup
      .date()
      .nullable()
      .when('delivery_required', {
        is: true,
        then: (schema) => schema.required('Delivery date is required'),
      }),

    deliveryTimeSlot: yup
      .string()
      .nullable()
      .when('delivery_required', {
        is: true,
        then: (schema) => schema.required('Delivery time slot is required'),
      }),

    service_required: yup.boolean(),
    delivery_required: yup.boolean(),
    useExistingBillingAddress: yup.boolean(),
    billingAddress: yup
      .object({
        house_number: yup.string().max(50).matches(addressPattern).trim(),
        street_name: yup
          .string()
          .max(50, 'Field cannot exceed 50 character')
          .matches(
            addressPattern,
            'Address should not contain any special character'
          )
          .trim(),
        state: yup.string().trim(),
        city: yup
          .string()
          .max(50, 'Field cannot exceed 50 character')
          .matches(alphabet, 'City Name should be only alphabet')
          .trim(),
        country: yup
          .string()
          .max(50, 'Field cannot exceed 50 character')
          .matches(alphabet, 'Country Name should be only alphabet')
          .trim(),
        postalCode: yup
          .string()
          .matches(UKPostalCode, 'Enter a valid postal code')
          .trim(),
        phone_number: yup
          .string()
          .matches(phoneNumber, 'Enter a valid phone number')
          .trim(),
        notes: yup
          .string()
          .matches(
            alphaNumericPattern,
            'Message cannot not contain any special character'
          )
          .max(250, 'Message cannot exceed 250 character')
          .trim(),
      })
      .when('useExistingBillingAddress', {
        is: (value: boolean) => {
          return value === false;
        },
        then: (schema) =>
          schema.shape({
            house_number: yup
              .string()
              .required('House number and street name is required')
              .max(50, 'Field cannot exceed 50 character')
              .matches(
                addressPattern,
                'Address should not contain any special character'
              )
              .trim(),
            state: yup.string().trim(),
            city: yup
              .string()
              .required('City is required')
              .max(50, 'Field cannot exceed 50 character')
              .matches(alphabet, 'City Name should be only alphabet')
              .trim(),
            postalCode: yup
              .string()
              .required('Postal code is required')
              .matches(UKPostalCode, 'Enter a valid postal code')
              .trim(),
            phone_number: yup
              .string()
              .required('Phone number is required')
              .matches(phoneNumber, 'Enter a valid phone number')
              .trim(),
          }),
      }),
    isShippingDifferentAsBilling: yup.boolean().default(false),
    agree_t_c: yup.boolean().required('Accept T&C to proceed').oneOf([true]),
    shippingAddress: yup.object({
      house_number: yup
        .string()
        .when(['isShippingDifferentAsBilling', 'useExistingShippingAddress'], {
          is: (isShippingDifferent: boolean, useExisting: boolean) =>
            isShippingDifferent && !useExisting,
          then: (schema) =>
            schema
              .required('House number and street name is required')
              .max(50, 'Field cannot exceed 50 character')
              .matches(
                addressPattern,
                'Address should not contain any special character'
              )
              .trim(),
        }),
      street_name: yup
        .string()
        .when(['isShippingDifferentAsBilling', 'useExistingShippingAddress'], {
          is: (isShippingDifferent: boolean, useExisting: boolean) =>
            isShippingDifferent && !useExisting,
          then: (schema) =>
            schema
              .max(50, 'Field cannot exceed 50 character')
              .matches(
                addressPattern,
                'Address should not contain any special character'
              )
              .trim(),
        }),
      city: yup
        .string()
        .when(['isShippingDifferentAsBilling', 'useExistingShippingAddress'], {
          is: (isShippingDifferent: boolean, useExisting: boolean) =>
            isShippingDifferent && !useExisting,
          then: (schema) =>
            schema
              .required('City is required')
              .max(50, 'Field cannot exceed 50 character')
              .matches(alphabet, 'City Name should be only alphabet')
              .trim(),
        }),
      state: yup
        .string()
        .when(['isShippingDifferentAsBilling', 'useExistingShippingAddress'], {
          is: (isShippingDifferent: boolean, useExisting: boolean) =>
            isShippingDifferent && !useExisting,
          then: (schema) => schema.trim(),
        }),
      country: yup
        .string()
        .when(['isShippingDifferentAsBilling', 'useExistingShippingAddress'], {
          is: (isShippingDifferent: boolean, useExisting: boolean) =>
            isShippingDifferent && !useExisting,
          then: (schema) =>
            schema
              .max(50, 'Field cannot exceed 50 character')
              .matches(alphabet, 'Country Name should be only alphabet')
              .trim(),
        }),
      postalCode: yup
        .string()
        .when(['isShippingDifferentAsBilling', 'useExistingShippingAddress'], {
          is: (isShippingDifferent: boolean, useExisting: boolean) =>
            isShippingDifferent && !useExisting,
          then: (schema) =>
            schema
              .required('Postal code is required')
              .matches(UKPostalCode, 'Enter a valid postal code')
              .trim(),
        }),
      phone_number: yup
        .string()
        .when(['isShippingDifferentAsBilling', 'useExistingShippingAddress'], {
          is: (isShippingDifferent: boolean, useExisting: boolean) =>
            isShippingDifferent && !useExisting,
          then: (schema) =>
            schema
              .required('Phone number is required')
              .matches(phoneNumber, 'Enter a valid phone number')
              .trim(),
        }),
    }),
    useExistingShippingAddress: yup.boolean(),
  });

  const {
    handleSubmit: billingFormSubmit,
    control: billingFormControl,
    reset: billingFormReset,
    setValue: billingFormSetValue,
    getValues: billingFormGetValue,
    trigger: billingFormTrigger,
    formState: { errors: billingFormErrors, isValid: billingFormValidity },
  } = useForm({
    resolver: yupResolver(FormSchema),
    defaultValues: {
      useExistingBillingAddress: false,
      useExistingShippingAddress: false,
      isShippingDifferentAsBilling: false,
      service_required: (checkoutDetails as any)?.service_required || false,
      delivery_required: (checkoutDetails as any)?.delivery_required || false,
      serviceDate: null,
      deliveryDate: null,
      serviceTimeSlot: '',
      deliveryTimeSlot: '',
    },
  });
  const shippingDifferentAsBillingValue = useWatch({
    control: billingFormControl,
    name: 'isShippingDifferentAsBilling',
  });

  const useStreetaddress = useWatch({
    control: billingFormControl,
    name: 'billingAddress.house_number',
  });

  const usePostalcode = useWatch({
    control: billingFormControl,
    name: 'billingAddress.postalCode',
  });

  const useCity = useWatch({
    control: billingFormControl,
    name: 'billingAddress.city',
  });

  const shippingAddress = useWatch({
    control: billingFormControl,
    name: 'shippingAddress.house_number',
  });
  const shippingPostalcode = useWatch({
    control: billingFormControl,
    name: 'shippingAddress.postalCode',
  });

  const shippingCity = useWatch({
    control: billingFormControl,
    name: 'shippingAddress.city',
  });

  const [_devliverycharge, setDeliveryCharge] = useState<any>(null);
  const [_isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const hasCartItems = Array.isArray(cartItems) && cartItems.length > 0;
    if (!hasCartItems) {
      setDeliveryCharge(null);
      return;
    }

    const billingStreet = useExistingBillingAddress
      ? (selectedBillingAddress as any)?.address
      : useStreetaddress;
    const billingPostal = useExistingBillingAddress
      ? (selectedBillingAddress as any)?.zip
      : usePostalcode;
    const billingCityValue = useExistingBillingAddress
      ? (selectedBillingAddress as any)?.city
      : useCity;

    const shippingStreet = useExistingShippingAddress
      ? (selectedShippingAddress as any)?.address
      : shippingAddress;
    const shippingPostal = useExistingShippingAddress
      ? (selectedShippingAddress as any)?.zip
      : shippingPostalcode;
    const shippingCityValue = useExistingShippingAddress
      ? (selectedShippingAddress as any)?.city
      : shippingCity;

    const isBillingComplete = !!(
      billingStreet &&
      billingPostal &&
      billingCityValue
    );
    const isShippingEnabled = !!shippingDifferentAsBillingValue;
    const isShippingComplete = !!(
      shippingStreet &&
      shippingPostal &&
      shippingCityValue
    );

    if (!isBillingComplete) return;
    if (isShippingEnabled && !isShippingComplete) return;

    const payload = {
      billing_address: `${billingStreet}, ${billingPostal}, ${billingCityValue}`,
      shipping_address: isShippingEnabled
        ? `${shippingStreet}, ${shippingPostal}, ${shippingCityValue}`
        : '',
      sub_total: subtotal,
    };

    const requestKey = JSON.stringify(payload);
    if (lastDeliveryChargeRequestKeyRef.current === requestKey) return;

    const timer = setTimeout(async () => {
      setIsLoading(true);
      try {
        const response = await postData(
          end_points.calculateDeliveryCharge.url,
          payload
        );
        if (response.status == 200) {
          lastDeliveryChargeRequestKeyRef.current = requestKey;
          setDeliveryCharge(response.data.data);
        } else {
          toast.error('Failed to calculate delivery charge');
        }
      } catch (error) {
        console.error('Error calculating delivery charge:', error);
      } finally {
        setIsLoading(false);
      }
    }, 1000);

    return () => clearTimeout(timer);
  }, [
    usePostalcode,
    subtotal,
    shippingDifferentAsBillingValue,
    useStreetaddress,
    useCity,
    shippingPostalcode,
    shippingAddress,
    shippingCity,
    useExistingBillingAddress,
    useExistingShippingAddress,
    selectedBillingAddress,
    selectedShippingAddress,
    cartItems,
  ]);
  const shippingCostFromDeliveryApi = useMemo(() => {
    const cost = Number((_devliverycharge as any)?.shipping_cost ?? 0);
    return Number.isFinite(cost) ? cost : 0;
  }, [_devliverycharge]);

  const amountPayable = useMemo(() => {
    const apiGrandTotal = Number((_devliverycharge as any)?.grand_total);
    if (Number.isFinite(apiGrandTotal) && apiGrandTotal >= 0) {
      const adjusted =
        apiGrandTotal -
        calculateDiscount -
        calculateCouponDiscount -
        giftCardAmountToUse;
      return Math.max(0, adjusted);
    }
    return total();
  }, [
    _devliverycharge,
    calculateDiscount,
    calculateCouponDiscount,
    giftCardAmountToUse,
  ]);

  useEffect(() => {
    if (selectedBillingAddress && useExistingBillingAddress) {
      // Set billing address values directly without undefined fallbacks
      billingFormSetValue('billingAddress', {
        house_number: selectedBillingAddress.address,
        street_name: selectedBillingAddress.house_number,
        city: selectedBillingAddress.city,
        state: selectedBillingAddress.state,
        country: selectedBillingAddress.country,
        postalCode: selectedBillingAddress.zip,
        phone_number: selectedBillingAddress.phone_number,
      });
      // Ensure the form state is properly updated
      billingFormSetValue('useExistingBillingAddress', true);
      // Trigger validation to update form state
      billingFormTrigger('billingAddress');
    }
  }, [
    selectedBillingAddress,
    useExistingBillingAddress,
    billingFormSetValue,
    billingFormTrigger,
  ]);

  useEffect(() => {
    if (selectedShippingAddress && useExistingShippingAddress) {
      billingFormSetValue('shippingAddress', {
        house_number: selectedShippingAddress.address,
        street_name: selectedShippingAddress.house_number,
        city: selectedShippingAddress.city,
        state: selectedShippingAddress.state,
        country: selectedShippingAddress.country,
        postalCode: selectedShippingAddress.zip,
        phone_number: selectedShippingAddress.phone_number,
      });
      // Ensure the form state is properly updated
      billingFormSetValue('useExistingShippingAddress', true);
      // Trigger validation to update form state
      billingFormTrigger('shippingAddress');
    }
  }, [
    selectedShippingAddress,
    useExistingShippingAddress,
    billingFormSetValue,
    billingFormTrigger,
  ]);

  useEffect(() => {
    if (checkoutDetails) {
      billingFormSetValue(
        'service_required',
        (checkoutDetails as any).service_required
      );
      billingFormSetValue(
        'delivery_required',
        (checkoutDetails as any).delivery_required
      );
      // Don't set default dates - let user select them
    }
  }, [checkoutDetails, billingFormSetValue]);

  // Validate and clear delivery date if it becomes invalid (e.g., becomes a holiday)
  useEffect(() => {
    if (deliveryDate && deliveryHolidays.length > 0) {
      // Check if the currently selected delivery date is a holiday or outside allowed range
      if (!isDeliveryDateSelectable(deliveryDate)) {
        setDeliveryDate(null);
        billingFormSetValue('deliveryDate', null);
        toast.warning(
          'The selected delivery date is no longer available. Please select a new date.'
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deliveryHolidays, nextDeliveryDate]);

  const onGetOrderId = async () => {
    try {
      const payload = new FormData();
      const amountInPaise = Math.round(total() * 100);
      payload.append('amount', amountInPaise);
      payload.append('currency', currencyCode);
      // payload.append('currency', 'INR');
      const response = await postData('razorpay_order', payload);
      if (response.status == 200) {
        // setOrderId(response?.data?.data?.razorpay_order_id);
        return response?.data?.data?.razorpay_order_id;
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handlePaymentSuccess = async (data: any) => {
    // Extract the transaction ID and any other necessary details
    const { transactionId } = data;

    try {
      const orderData = {
        transactionId,
        // add any other details you need for order placement
      };

      // Call the function that handles order placement
      await onHandlePaymentConfirmation(transactionId, orderData);
    } catch (error) {
      console.error('Payment handling failed:', error);
    }
  };

  const onHandlePaymentConfirmation = async (transactionId = '', data) => {
    try {
      setIsPlacingOrder(true);
      const billingAddressData = useExistingBillingAddress
        ? selectedBillingAddress
        : data?.billingAddress;

      const shippingAddressData = shipping
        ? useExistingShippingAddress
          ? selectedShippingAddress
          : data?.shippingAddress
        : billingAddressData;

      const transformedCartItems = cartItems.map((item) => {
        // Normalize ID to string because some cart sources provide numeric IDs.
        const itemId = String(item?.id ?? '');
        // Extract base product ID from item.id (remove variant suffix if exists)
        const baseProductId = itemId.includes('_')
          ? itemId.split('_')[0]
          : itemId;

        return {
          id: String(baseProductId), // Use only the base product ID
          image: item.image || '',
          name: item.name || '',
          slug: null,
          qty: String(item.quantity),
          sale_unit_id: 1, // defaulting as in your sample
          unit_price: parseFloat(item.price),
          total_price: parseFloat(item.price) * parseFloat(item.quantity),
          // variant: item.variant != '' ? [item?.variant] : 0,
          is_express: itemId.includes('_express'), // Add flag for express service
          variant: 0,
        };
      });

      if (useExistingBillingAddress) {
        if (
          billingAddressData?.phone_number == '' ||
          billingAddressData?.house_number == '' ||
          billingAddressData?.city == '' ||
          billingAddressData?.postalCode == ''
        ) {
          toast.error('Please enter valid billing address details');
          setIsPlacingOrder(false);
          return;
        }
      }

      // Condition for different shipping address
      if (useExistingShippingAddress) {
        if (
          shippingAddressData?.phone_number == '' ||
          shippingAddressData?.house_number == '' ||
          shippingAddressData?.city == '' ||
          shippingAddressData?.postalCode == ''
        ) {
          toast.error('Please enter valid shipping address details');
          setIsPlacingOrder(false);
          return;
        }
      }

      // Check if final payable equals minimum amount - if so, don't pass discount/coupon
      // Exception: If discountAffectsMinimum is 1, always pass discount/coupon (we're ignoring minimum)
      const finalPayable = total();
      // grand_total should always be the total before gift card (original order total)
      // This represents the actual order value, not what the customer pays
      // finalPayable is what customer actually pays (after gift card deduction)
      const grandTotal = getTotalBeforeGiftCard;

      const shouldPassDiscount =
        minimumOrderAmount === 0 ||
        discountAffectsMinimum === 1 ||
        (discountAffectsMinimum === 0 && grandTotal !== minimumOrderAmount);
      const shouldPassCoupon =
        minimumOrderAmount === 0 ||
        discountAffectsMinimum === 1 ||
        (discountAffectsMinimum === 0 && grandTotal !== minimumOrderAmount);

      // If gift card covers full payment, set payment mode to 'gift_card'
      const finalPaymentMode = isGiftCardFullPayment
        ? 'gift_card'
        : paymentGateway;

      const payload = {
        currency: currencyCode,
        currency_id: currencyId,
        billing_name: customerDetails?.name,
        billing_email: customerDetails?.email,
        billing_phone:
          customerDetails?.phone_number || billingAddressData?.phone_number,
        billing_address:
          `${billingAddressData?.house_number || ''} ${billingAddressData?.street_name || ''} ${billingAddressData?.address || ''}`.trim(),
        billing_city: billingAddressData?.city || '',
        billing_state: billingAddressData?.state || '',
        billing_zip:
          billingAddressData?.postalCode || billingAddressData?.zip || '',
        billing_country: billingAddressData?.country || '',

        shipping_name: customerDetails?.name,
        shipping_email: customerDetails?.email,
        shipping_phone:
          customerDetails?.phone_number || shippingAddressData?.phone_number,
        shipping_address:
          `${shippingAddressData?.house_number || ''} ${shippingAddressData?.street_name || ''} ${shippingAddressData?.address || ''}`.trim(),
        shipping_city: shippingAddressData?.city || '',
        shipping_state: shippingAddressData?.state || '',
        shipping_zip:
          shippingAddressData?.postalCode || shippingAddressData?.zip || '',
        shipping_country: shippingAddressData?.country || '',
        sale_note: data?.billingAddress?.notes || '',
        payment_mode: finalPaymentMode,
        stripe_token: data?.stripeToken || data?.paymentMethodId || '',
        transaction_id: transactionId,
        payment_method_id: data?.paymentMethodId || null,
        setup_intent_id: data?.setupIntentId || null,
        is_saved_card: data?.isSavedCard || false,
        item: cartItems?.length || 0,
        total_qty: totalQuantity,
        total_discount:
          shouldPassDiscount && selectedDiscount ? calculateDiscount || 0 : 0,
        total_tax: 0,
        sub_total: subtotal,
        grand_total: grandTotal,
        coupon_id:
          shouldPassCoupon && selectedCoupon ? selectedCoupon.id : null,
        coupon_discount: shouldPassCoupon ? calculateCouponDiscount || 0 : 0,
        coupon_code:
          shouldPassCoupon && selectedCoupon ? selectedCoupon.code : null,
        gift_card_id:
          selectedGiftCard && giftCardAmountToUse > 0
            ? selectedGiftCard.id
            : null,
        gift_card_amount:
          selectedGiftCard && giftCardAmountToUse > 0 ? giftCardAmountToUse : 0,
        gift_card_no:
          selectedGiftCard && giftCardAmountToUse > 0
            ? selectedGiftCard.card_no
            : null,
        discount_id:
          shouldPassDiscount && selectedDiscount
            ? selectedDiscount.id || null
            : null,
        discount_name:
          shouldPassDiscount && selectedDiscount
            ? selectedDiscount.name || null
            : null,
        discount_type:
          shouldPassDiscount && selectedDiscount
            ? selectedDiscount.type || null
            : null,
        discount_value:
          shouldPassDiscount && selectedDiscount
            ? selectedDiscount.value || null
            : null,
        shipping_cost:
          currentLocation &&
          (serviceType === 'pick_and_drop' ||
            (!shouldShowServiceTypeSelection() &&
              parseFloat(currentLocation.shipping_cost) > 0))
            ? currentLocation.shipping_cost
            : '0',
        delivery_cost:
          currentLocation &&
          (serviceType === 'delivery' ||
            (!shouldShowServiceTypeSelection() &&
              parseFloat(currentLocation.delivery_cost) > 0))
            ? currentLocation.delivery_cost
            : '0',
        cart: transformedCartItems,
        service_date: serviceDate ? format(serviceDate, 'yyyy-MM-dd') : '',
        ...(hostname !== 'laundry-lounge.co.uk' && {
          service_time_slot_id: serviceTimeSlot || '',
        }),
        delivery_date: deliveryDate ? format(deliveryDate, 'yyyy-MM-dd') : '',
        delivery_time_slot_id: deliveryTimeSlot || '',
        sale_status: isGiftCardFullPayment
          ? '1'
          : finalPaymentMode == 'cod'
            ? '2'
            : '1',
        payment_status: isGiftCardFullPayment
          ? '4'
          : finalPaymentMode == 'cod'
            ? '1'
            : '4',
        order_type: 'service',
        delivery_service_mode: null, // Deprecated, use specific service modes below
        selected_delivery_service: null, // Deprecated, use specific service modes below
        laundry_service_mode: (() => {
          const serviceModeInfo = getServiceModeToShow();
          if (serviceModeInfo?.type === 'laundry' && serviceModeInfo.selected) {
            // Map string values to integers: 'drop_off_collection' = 1, 'pickup_delivery' = 2
            if (serviceModeInfo.selected === 'drop_off_collection') return 1;
            if (serviceModeInfo.selected === 'pickup_delivery') return 2;
          }
          return null;
        })(),
        restaurant_service_mode: (() => {
          const serviceModeInfo = getServiceModeToShow();
          if (
            serviceModeInfo?.type === 'restaurant' &&
            serviceModeInfo.selected
          ) {
            // Map string values to integers: 'dine_in' = 1, 'takeaway' = 2, 'delivery' = 3
            if (serviceModeInfo.selected === 'dine_in') return 1;
            if (serviceModeInfo.selected === 'takeaway') return 2;
            if (serviceModeInfo.selected === 'delivery') return 3;
          }
          return null;
        })(),
        field_service_mode: (() => {
          const serviceModeInfo = getServiceModeToShow();
          if (serviceModeInfo?.type === 'field' && serviceModeInfo.selected) {
            // Map string values to integers: 'in_store_appointment' = 1, 'on_site_appointment' = 2
            if (serviceModeInfo.selected === 'in_store_appointment') return 1;
            if (serviceModeInfo.selected === 'on_site_appointment') return 2;
          }
          return null;
        })(),
        // Card details for Stripe payments
        ...(paymentGateway.toLowerCase() === 'stripe' &&
          (() => {
            // Existing card (card_status = 1)
            if (data?.isSavedCard && selectedCard?.id) {
              return {
                card_details: {
                  card_status: 1,
                  card_id: selectedCard.id,
                  setup_intent_id: null,
                },
              };
            }
            // New card (card_status = 0) - has setup intent ID
            else if (data?.setupIntentId) {
              return {
                card_details: {
                  card_status: 0,
                  setup_intent_id: data.setupIntentId,
                  card_id: null,
                },
              };
            }
            // If no card details available, don't include card_details
            return {};
          })()),
      };

      const response = await postData('place_order', payload);
      if (response?.data?.success) {
        toast.success('Order placed successfully');
        // Keep button disabled during navigation
        dispatch(setActiveCustomerTab('orders'));
        dispatch(clearCart());
        navigate(routes.customerDashboard);
        // Reset loading state after navigation
        setIsPlacingOrder(false);
      } else {
        setIsPlacingOrder(false);
        toast.error('Failed to place order. Please try again.');
      }
    } catch (error) {
      console.error('Failed to placeee order:', error);
      toast.error('Failed to place order. Please try again.');
      setIsPlacingOrder(false);
    }
  };

  const handlePayPal = (details) => {
    setPaypalDetails(details);
    setIsPaypalModalOpen(true);
  };

  const handleStripe = async (details) => {
    setStripeDetails(details); // Save billing/shipping details

    // If saved card is selected, proceed directly without modal
    if (selectedCard && !useNewCard) {
      // Button is already disabled from handlePaymentGateway
      await onHandlePaymentConfirmation('', {
        ...details,
        paymentMethodId: selectedCard.id,
        isSavedCard: true,
      });
      return;
    }

    // For new card or no saved cards, create setup intent and open modal
    try {
      // Button is already disabled from handlePaymentGateway
      const clientSecret = await createSetupIntent();
      if (clientSecret) {
        // Open modal after setup intent is created
        // Button stays disabled until modal is closed or order is placed
        setIsModalOpen(true);
      } else {
        toast.error('Failed to initialize payment. Please try again.');
        setIsPlacingOrder(false); // Re-enable button on error
      }
    } catch (error) {
      console.error('Error in handleStripe:', error);
      toast.error('Failed to process payment. Please try again.');
      setIsPlacingOrder(false); // Re-enable button on error
    }
  };

  const handleRazorpay = async (details) => {
    const orderId = await onGetOrderId();

    const YOUR_RAZORPAY_KEY = checkoutDetails?.gateways?.find(
      (gateway) => gateway?.name === 'Razorpay'
    )?.key;

    try {
      if (!orderId) {
        throw new Error('Failed to generate order ID.');
      }

      const amountInPaise = Math.round(total() * 100);

      const options = {
        key: YOUR_RAZORPAY_KEY,
        amount: amountInPaise,
        currency: currencyCode,
        // currency: 'INR',
        name: 'E-Commerce',
        description: 'Payment for invoice',
        image: 'https://yourlogo.com/logo.png',
        order_id: orderId,

        handler: async function (response) {
          await onHandlePaymentConfirmation(
            response.razorpay_payment_id,
            details
          );
        },

        theme: {
          color: '#3399cc',
        },

        modal: {
          ondismiss: function () {
            console.warn('Payment popup closed by user.');
          },
        },
      };

      const razorpay = new window.Razorpay(options);

      razorpay.on('payment.failed', function (response) {
        console.error('Payment failed:', response.error);
      });

      razorpay.open();
    } catch (error) {
      console.error('Error initializing Razorpay:', error);
    }
  };

  const handleCOD = async (details) => {
    await onHandlePaymentConfirmation('', details);
  };

  const handleGiftCard = async (details) => {
    // Gift card covers full payment, no transaction ID needed
    await onHandlePaymentConfirmation('', details);
  };

  const gatewayHandlers = {
    paypal: handlePayPal,
    stripe: handleStripe,
    razorpay: handleRazorpay,
    cod: handleCOD,
    gift_card: handleGiftCard,
  };

  const handlePaymentGateway = async (details: any) => {
    console.log('handlePaymentGateway called');
    console.log('details', details);
    console.log('paymentGateway:', paymentGateway);
    console.log('billingFormValidity:', billingFormValidity);
    console.log('billingFormErrors:', billingFormErrors);

    const gatewayKey = paymentGateway.toLowerCase();

    const selectedGateway = gateways?.find(
      (g) => g?.name.toLowerCase() === gatewayKey
    );

    const handler = gatewayHandlers[gatewayKey];

    console.log('gatewayKey:', gatewayKey);
    console.log('selectedGateway:', selectedGateway);
    console.log('handler:', handler);

    if (handler) {
      // Disable button at the start of payment process
      if (gatewayKey === 'stripe') {
        setIsPlacingOrder(true);
      }

      if (selectedGateway) {
        await handler(details);
      } else {
        await handler(details);
      }
    } else {
      console.log(`No handler found for: ${paymentGateway}`);
      toast.error(`No payment handler found for ${paymentGateway}`);
    }
  };

  return (
    <>
      {loading ? (
        <Spinner />
      ) : (
        <>
          <div className="container">
            <form
              onSubmit={billingFormSubmit(handlePaymentGateway, (errors) => {
                console.log('Form submit blocked by validation');
                console.log('Form validity:', billingFormValidity);
                console.log('Form errors object:', errors);
                console.log(
                  'Current values:',
                  JSON.stringify(billingFormGetValue(), null, 2)
                );
                console.log(
                  'useExistingBillingAddress:',
                  useExistingBillingAddress
                );
                console.log('selectedBillingAddress:', selectedBillingAddress);

                toast.error('Please fill in all required fields correctly');
              })}
            >
              <div className="row justify-content-center mt-4">
                <div className="col-md-7">
                  <div className="card-box">
                    <div className="card-header">
                      <h2>
                        {hostname === 'laundry-lounge.co.uk'
                          ? 'Drop-Off Service '
                          : 'Service Dates'}
                      </h2>
                    </div>
                    <div className="card-body">
                      {/* Service Section */}
                      {checkoutDetails?.service_required && (
                        <>
                          <div className="row">
                            <div className="col-md-6">
                              <div className="mb-3">
                                <label>
                                  {hostname === 'laundry-lounge.co.uk'
                                    ? 'Drop-Off Date'
                                    : 'Service Date'}
                                  <span className="text-danger">*</span>
                                </label>
                                <Controller
                                  name="serviceDate"
                                  control={billingFormControl}
                                  render={({ field }) => (
                                    <DatePicker
                                      selected={field.value || null}
                                      onChange={(date) => {
                                        console.log(
                                          'Service date selected:',
                                          date
                                        );
                                        field.onChange(date);
                                        setServiceDate(date);
                                        // Call get_delivery_dates API when service date is selected
                                        if (date) {
                                          console.log(
                                            'Calling getDeliveryDates with date:',
                                            date
                                          );
                                          getDeliveryDates(date);
                                        }
                                      }}
                                      filterDate={isDateSelectable}
                                      minDate={getNextValidDate(today)}
                                      dateFormat="yyyy-MM-dd"
                                      placeholderText="Select service date"
                                      className={`form-control ${billingFormErrors.serviceDate ? 'invalid' : ''}`}
                                    />
                                  )}
                                />
                                {billingFormErrors.serviceDate && (
                                  <small className="text-danger">
                                    {billingFormErrors.serviceDate.message}
                                  </small>
                                )}
                              </div>
                            </div>
                            {hostname !== 'laundry-lounge.co.uk' && (
                              <div className="col-md-6">
                                <div className="mb-3">
                                  <label>
                                    Service Time Slot{' '}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <Controller
                                    name="serviceTimeSlot"
                                    control={billingFormControl}
                                    render={({ field }) => (
                                      <select
                                        {...field}
                                        onChange={(e) => {
                                          field.onChange(e);
                                          setServiceTimeSlot(e.target.value);
                                        }}
                                        className={`form-control ${billingFormErrors.serviceTimeSlot ? 'invalid' : ''}`}
                                      >
                                        <option value="">
                                          Select a timeslot
                                        </option>
                                        {(checkoutDetails?.service_time_slots &&
                                        checkoutDetails.service_time_slots
                                          .length > 0
                                          ? checkoutDetails.service_time_slots
                                          : checkoutDetails?.timeslots
                                        )?.map((option) => (
                                          <option
                                            key={option.id}
                                            value={option.id}
                                          >
                                            {option.time_slot}
                                          </option>
                                        ))}
                                      </select>
                                    )}
                                  />
                                  {billingFormErrors.serviceTimeSlot && (
                                    <small className="text-danger">
                                      {
                                        billingFormErrors.serviceTimeSlot
                                          .message
                                      }
                                    </small>
                                  )}
                                </div>
                              </div>
                            )}
                          </div>
                        </>
                      )}

                      {/* Delivery Section */}
                      {checkoutDetails?.delivery_required && (
                        <div className="row">
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label>
                                Delivery Date{' '}
                                <span className="text-danger">*</span>
                              </label>
                              <br />
                              <Controller
                                name="deliveryDate"
                                control={billingFormControl}
                                render={({ field }) => (
                                  <DatePicker
                                    selected={
                                      field.value ||
                                      (nextDeliveryDate
                                        ? parseISO(nextDeliveryDate)
                                        : null)
                                    }
                                    onChange={(date) => {
                                      // Only allow selection if the date is selectable (not disabled)
                                      if (
                                        date &&
                                        isDeliveryDateSelectable(date)
                                      ) {
                                        field.onChange(date);
                                        setDeliveryDate(date);
                                      } else if (date) {
                                        // If date is disabled, don't set it and show a warning
                                        toast.warning(
                                          'This date is not available for delivery. Please select another date.'
                                        );
                                      }
                                    }}
                                    filterDate={isDeliveryDateSelectable}
                                    minDate={
                                      nextDeliveryDate
                                        ? parseISO(nextDeliveryDate)
                                        : undefined
                                    }
                                    maxDate={getLastDeliveryToDate()}
                                    dateFormat="yyyy-MM-dd"
                                    placeholderText={
                                      deliveryDatesLoaded
                                        ? 'Select delivery date'
                                        : 'Please select service date first'
                                    }
                                    disabled={!deliveryDatesLoaded}
                                    className={`form-control ${billingFormErrors.deliveryDate ? 'invalid' : ''}`}
                                  />
                                )}
                              />
                              {billingFormErrors.deliveryDate && (
                                <small className="text-danger">
                                  {billingFormErrors.deliveryDate.message}
                                </small>
                              )}
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label>
                                Delivery Time Slot{' '}
                                <span className="text-danger">*</span>
                              </label>
                              <Controller
                                name="deliveryTimeSlot"
                                control={billingFormControl}
                                render={({ field }) => (
                                  <select
                                    {...field}
                                    onChange={(e) => {
                                      field.onChange(e);
                                      setDeliveryTimeSlot(e.target.value);
                                    }}
                                    className={`form-control ${billingFormErrors.deliveryTimeSlot ? 'invalid' : ''}`}
                                  >
                                    <option value="">Select a timeslot</option>
                                    {(checkoutDetails?.delivery_time_slots &&
                                    checkoutDetails.delivery_time_slots.length >
                                      0
                                      ? checkoutDetails.delivery_time_slots
                                      : checkoutDetails?.timeslots
                                    )?.map((option) => (
                                      <option key={option.id} value={option.id}>
                                        {option.time_slot}
                                      </option>
                                    ))}
                                  </select>
                                )}
                              />
                              {billingFormErrors.deliveryTimeSlot && (
                                <small className="text-danger">
                                  {billingFormErrors.deliveryTimeSlot.message}
                                </small>
                              )}
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="card-box">
                    <div className="card-header">
                      <h2>Billing address</h2>
                    </div>
                    <div className="row">
                      {address.length > 0 && (
                        <div className="col-md-12">
                          <div className="mb-3">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                checked={useExistingBillingAddress}
                                onChange={(e) => {
                                  setUseExistingBillingAddress(
                                    e.target.checked
                                  );
                                  billingFormSetValue(
                                    'useExistingBillingAddress',
                                    e.target.checked
                                  );
                                }}
                                id="useExistingBillingAddress"
                              />
                              <label
                                className="form-check-label"
                                htmlFor="useExistingBillingAddress"
                              >
                                Use existing address
                              </label>
                            </div>

                            {useExistingBillingAddress && (
                              <div className="mt-3">
                                <div className="row">
                                  {address.map((addr) => (
                                    <div className="col-12 mb-3" key={addr.id}>
                                      <div
                                        className={`card address-card ${selectedBillingAddress?.id === addr.id ? 'selected' : ''}`}
                                        onClick={() =>
                                          setSelectedBillingAddress(addr)
                                        }
                                      >
                                        <div className="card-body">
                                          <h5 className="card-title">
                                            {addr.name || 'Address'}
                                          </h5>
                                          <p className="card-text">
                                            {addr.address}
                                            <br />
                                            {addr.city}, {addr.state}
                                            <br />
                                            {addr.country}, {addr.zip}
                                          </p>
                                          <div className="form-check">
                                            <input
                                              type="radio"
                                              className="form-check-input"
                                              checked={
                                                selectedBillingAddress?.id ===
                                                addr.id
                                              }
                                              onChange={() => {}}
                                            />
                                            <label className="form-check-label">
                                              Select this address
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                    {(!useExistingBillingAddress || address.length === 0) && (
                      <>
                        <div className="row">
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label>
                                Street address{' '}
                                <span className="text-danger">*</span>
                              </label>
                              <Controller
                                name="billingAddress.house_number"
                                control={billingFormControl}
                                render={({ field }) => (
                                  <input
                                    {...field}
                                    className={`form-control ${
                                      billingFormErrors.billingAddress
                                        ?.house_number
                                        ? 'invalid'
                                        : ''
                                    }`}
                                  />
                                )}
                              />
                              {billingFormErrors.billingAddress
                                ?.house_number ? (
                                <small className="text-danger">
                                  {
                                    billingFormErrors.billingAddress
                                      ?.house_number?.message
                                  }
                                </small>
                              ) : null}
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label>Street Name</label>
                              <Controller
                                name="billingAddress.street_name"
                                control={billingFormControl}
                                render={({ field }) => (
                                  <input
                                    {...field}
                                    placeholder="Optional"
                                    className={`form-control ${
                                      billingFormErrors.billingAddress
                                        ?.street_name
                                        ? 'invalid'
                                        : ''
                                    }`}
                                  />
                                )}
                              />
                              {billingFormErrors.billingAddress?.street_name ? (
                                <small className="text-danger">
                                  {
                                    billingFormErrors.billingAddress
                                      ?.street_name?.message
                                  }
                                </small>
                              ) : null}
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label>
                                Town / City{' '}
                                <span className="text-danger">*</span>
                              </label>
                              <Controller
                                name="billingAddress.city"
                                control={billingFormControl}
                                render={({ field }) => (
                                  <input
                                    {...field}
                                    className={`form-control ${
                                      billingFormErrors.billingAddress?.city
                                        ? 'invalid'
                                        : ''
                                    }`}
                                  />
                                )}
                              />
                              {billingFormErrors.billingAddress?.city ? (
                                <small className="text-danger">
                                  {
                                    billingFormErrors.billingAddress?.city
                                      ?.message
                                  }
                                </small>
                              ) : null}
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label>State</label>
                              <Controller
                                name="billingAddress.state"
                                control={billingFormControl}
                                render={({ field }) => (
                                  <input
                                    {...field}
                                    placeholder="Optional"
                                    className={`form-control ${
                                      billingFormErrors.billingAddress?.state
                                        ? 'invalid'
                                        : ''
                                    }`}
                                  />
                                )}
                              />
                              {billingFormErrors.billingAddress?.state ? (
                                <small className="text-danger">
                                  {
                                    billingFormErrors.billingAddress?.state
                                      ?.message
                                  }
                                </small>
                              ) : null}
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label>Country</label>
                              <Controller
                                name="billingAddress.country"
                                control={billingFormControl}
                                render={({ field }) => (
                                  <input
                                    {...field}
                                    className={`form-control ${
                                      billingFormErrors.billingAddress?.country
                                        ? 'invalid'
                                        : ''
                                    }`}
                                  />
                                )}
                              />
                              {billingFormErrors.billingAddress?.country ? (
                                <small className="text-danger">
                                  {
                                    billingFormErrors.billingAddress?.country
                                      ?.message
                                  }
                                </small>
                              ) : null}
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label>
                                Postcode <span className="text-danger">*</span>
                              </label>
                              <Controller
                                name="billingAddress.postalCode"
                                control={billingFormControl}
                                render={({ field }) => (
                                  <input
                                    {...field}
                                    className={`form-control ${
                                      billingFormErrors.billingAddress
                                        ?.postalCode
                                        ? 'invalid'
                                        : ''
                                    }`}
                                  />
                                )}
                              />
                              {billingFormErrors.billingAddress?.postalCode ? (
                                <small className="text-danger">
                                  {
                                    billingFormErrors.billingAddress?.postalCode
                                      ?.message
                                  }
                                </small>
                              ) : null}
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label>
                                Phone Number{' '}
                                <span className="text-danger">*</span>
                              </label>
                              <Controller
                                name="billingAddress.phone_number"
                                control={billingFormControl}
                                render={({ field }) => (
                                  <input
                                    {...field}
                                    className={`form-control ${
                                      billingFormErrors.billingAddress
                                        ?.phone_number
                                        ? 'invalid'
                                        : ''
                                    }`}
                                  />
                                )}
                              />
                              {billingFormErrors.billingAddress
                                ?.phone_number ? (
                                <small className="text-danger">
                                  {
                                    billingFormErrors.billingAddress
                                      ?.phone_number?.message
                                  }
                                </small>
                              ) : null}
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                    <div className="row">
                      <div className="col-md-12">
                        <div className="mb-3">
                          <div className="form-check">
                            <Controller
                              name="isShippingDifferentAsBilling"
                              control={billingFormControl}
                              render={({ field }) => (
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  {...field}
                                  checked={shipping}
                                  value={String(shipping)}
                                  onChange={() => {
                                    billingFormSetValue(
                                      'isShippingDifferentAsBilling',
                                      !shipping
                                    );
                                    setShipping(!shipping);
                                  }}
                                  id="defaultCheck1"
                                />
                              )}
                            />

                            <label className="form-check-label">
                              Ship to a different address?
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    {shipping && (
                      <div className="checkout-list my-5">
                        <h2>Shipping address</h2>

                        {address.length > 0 && (
                          <div className="mb-3">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                checked={useExistingShippingAddress}
                                onChange={(e) => {
                                  setUseExistingShippingAddress(
                                    e.target.checked
                                  );
                                  billingFormSetValue(
                                    'useExistingShippingAddress',
                                    e.target.checked
                                  );
                                }}
                                id="useExistingShippingAddress"
                              />
                              <label
                                className="form-check-label"
                                htmlFor="useExistingShippingAddress"
                              >
                                Use existing address
                              </label>
                            </div>

                            {useExistingShippingAddress && (
                              <div className="mt-3">
                                <div className="row">
                                  {address.map((addr) => (
                                    <div className="col-12 mb-3" key={addr.id}>
                                      <div
                                        className={`card address-card ${selectedShippingAddress?.id === addr.id ? 'selected' : ''}`}
                                        onClick={() =>
                                          setSelectedShippingAddress(addr)
                                        }
                                      >
                                        <div className="card-body">
                                          <h5 className="card-title">
                                            {addr.name || 'Address'}
                                          </h5>
                                          <p className="card-text">
                                            {addr.address}
                                            <br />
                                            {addr.city}, {addr.state}
                                            <br />
                                            {addr.country}, {addr.zip}
                                          </p>
                                          <div className="form-check">
                                            <input
                                              type="radio"
                                              className="form-check-input"
                                              checked={
                                                selectedShippingAddress?.id ===
                                                addr.id
                                              }
                                              onChange={() => {}}
                                            />
                                            <label className="form-check-label">
                                              Select this address
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            )}
                          </div>
                        )}

                        {(!useExistingShippingAddress ||
                          address.length === 0) && (
                          <>
                            <div className="mb-3">
                              <label>
                                Street address{' '}
                                <span className="text-danger">*</span>
                              </label>
                              <Controller
                                name="shippingAddress.house_number"
                                control={billingFormControl}
                                render={({ field }) => (
                                  <input
                                    {...field}
                                    className={`form-control ${
                                      billingFormErrors.shippingAddress
                                        ?.house_number
                                        ? 'invalid'
                                        : ''
                                    }`}
                                  />
                                )}
                              />
                              {billingFormErrors.shippingAddress
                                ?.house_number ? (
                                <small className="text-danger">
                                  {
                                    billingFormErrors.shippingAddress
                                      ?.house_number?.message
                                  }
                                </small>
                              ) : null}
                            </div>
                            <div className="mb-3">
                              <label>Street Name</label>
                              <Controller
                                name="shippingAddress.street_name"
                                control={billingFormControl}
                                render={({ field }) => (
                                  <input
                                    {...field}
                                    placeholder="(Optional)"
                                    className={`form-control mt-2 ${
                                      billingFormErrors.shippingAddress
                                        ?.street_name
                                        ? 'invalid'
                                        : ''
                                    }`}
                                  />
                                )}
                              />
                            </div>
                            {billingFormErrors.shippingAddress?.street_name ? (
                              <small className="text-danger">
                                {
                                  billingFormErrors.shippingAddress?.street_name
                                    ?.message
                                }
                              </small>
                            ) : null}
                            <div className="mb-3">
                              <label>
                                Town / City{' '}
                                <span className="text-danger">*</span>
                              </label>
                              <Controller
                                name="shippingAddress.city"
                                control={billingFormControl}
                                render={({ field }) => (
                                  <input
                                    {...field}
                                    className={`form-control ${
                                      billingFormErrors.shippingAddress?.city
                                        ? 'invalid'
                                        : ''
                                    }`}
                                  />
                                )}
                              />
                              {billingFormErrors.shippingAddress?.city ? (
                                <small className="text-danger">
                                  {
                                    billingFormErrors.shippingAddress?.city
                                      ?.message
                                  }
                                </small>
                              ) : null}
                            </div>

                            <div className="mb-3">
                              <label>State</label>
                              <Controller
                                name="shippingAddress.state"
                                control={billingFormControl}
                                render={({ field }) => (
                                  <input
                                    {...field}
                                    placeholder="Optional"
                                    className={`form-control ${
                                      billingFormErrors.shippingAddress?.state
                                        ? 'invalid'
                                        : ''
                                    }`}
                                  />
                                )}
                              />
                              {billingFormErrors.shippingAddress?.state ? (
                                <small className="text-danger">
                                  {
                                    billingFormErrors.shippingAddress?.state
                                      ?.message
                                  }
                                </small>
                              ) : null}
                            </div>

                            <div className="mb-3">
                              <label>
                                Country <span className="text-danger">*</span>
                              </label>
                              <Controller
                                name="shippingAddress.country"
                                control={billingFormControl}
                                render={({ field }) => (
                                  <input
                                    {...field}
                                    className={`form-control ${
                                      billingFormErrors.shippingAddress?.country
                                        ? 'invalid'
                                        : ''
                                    }`}
                                  />
                                )}
                              />
                              {billingFormErrors.shippingAddress?.country ? (
                                <small className="text-danger">
                                  {
                                    billingFormErrors.shippingAddress?.country
                                      ?.message
                                  }
                                </small>
                              ) : null}
                            </div>
                            <div className="mb-3">
                              <label>
                                Postcode <span className="text-danger">*</span>
                              </label>
                              <Controller
                                name="shippingAddress.postalCode"
                                control={billingFormControl}
                                render={({ field }) => (
                                  <input
                                    {...field}
                                    className={`form-control ${
                                      billingFormErrors.shippingAddress
                                        ?.postalCode
                                        ? 'invalid'
                                        : ''
                                    }`}
                                  />
                                )}
                              />
                              {billingFormErrors.shippingAddress?.postalCode ? (
                                <small className="text-danger">
                                  {
                                    billingFormErrors.shippingAddress
                                      ?.postalCode?.message
                                  }
                                </small>
                              ) : null}
                            </div>
                            <div className="mb-3">
                              <label>
                                Phone Number{' '}
                                <span className="text-danger">*</span>
                              </label>
                              <Controller
                                name="shippingAddress.phone_number"
                                control={billingFormControl}
                                render={({ field }) => (
                                  <input
                                    {...field}
                                    className={`form-control ${
                                      billingFormErrors.shippingAddress
                                        ?.phone_number
                                        ? 'invalid'
                                        : ''
                                    }`}
                                  />
                                )}
                              />
                              {billingFormErrors.shippingAddress
                                ?.phone_number ? (
                                <small className="text-danger">
                                  {
                                    billingFormErrors.shippingAddress
                                      ?.phone_number?.message
                                  }
                                </small>
                              ) : null}
                            </div>
                          </>
                        )}
                      </div>
                    )}
                    <div className="mb-3">
                      <label>Order notes (optional)</label>
                      <Controller
                        name="billingAddress.notes"
                        control={billingFormControl}
                        render={({ field }) => (
                          <textarea
                            {...field}
                            className={`form-control ${
                              billingFormErrors.billingAddress?.notes
                                ? 'invalid'
                                : ''
                            }`}
                          ></textarea>
                        )}
                      />
                      {billingFormErrors.billingAddress?.notes ? (
                        <small className="text-danger">
                          {billingFormErrors.billingAddress?.notes?.message}
                        </small>
                      ) : null}
                    </div>
                  </div>
                </div>
                <div className="col-md-5">
                  <div className="amt-payable">
                    <div className="sec-hdr">
                      <h3>Your order</h3>
                    </div>
                    <div className="cs-option-amt">
                      {cartItems?.map((item: any) => {
                        return (
                          <>
                            <div className="cs-option-price p-0 mb-3">
                              <div className="cs-option-body">
                                <div className="cs-option-left">
                                  <span>{item?.name} </span>
                                  <span className="cs-option-pqty">
                                    ({item?.quantity})
                                  </span>
                                </div>
                                <div className="cs-option-right">
                                  {/* {settings?.WebmasterSettings?.currency} */}
                                  {currencySymbol}
                                  &nbsp;
                                  {(
                                    parseFloat(item?.quantity) *
                                    parseFloat(item?.price)
                                  ).toFixed(2)}
                                </div>
                              </div>
                            </div>
                          </>
                        );
                      })}
                      <div className="sec-hdr"></div>

                      {/* Service Mode Selection - Based on service_mode and product type */}
                      {(() => {
                        const serviceModeInfo = getServiceModeToShow();
                        if (!serviceModeInfo || serviceModeInfo.mode === null)
                          return null;

                        const { type, mode, selected, setSelected } =
                          serviceModeInfo;

                        // Laundry Service Mode (service_mode = 2)
                        if (type === 'laundry') {
                          return (
                            <>
                              <div className="mb-3">
                                <h5>
                                  {hostname === 'laundry-lounge.co.uk'
                                    ? 'Service Fee'
                                    : 'Delivery Service'}
                                </h5>
                                {mode === 1 && (
                                  <div className="form-check">
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      name="laundryService"
                                      id="dropOffCollection"
                                      value="drop_off_collection"
                                      checked={
                                        selected === 'drop_off_collection'
                                      }
                                      onChange={(e) =>
                                        setSelected(e.target.value)
                                      }
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="dropOffCollection"
                                    >
                                      Drop off and collection
                                    </label>
                                  </div>
                                )}
                                {mode === 2 && (
                                  <div className="form-check">
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      name="laundryService"
                                      id="pickupDelivery"
                                      value="pickup_delivery"
                                      checked={selected === 'pickup_delivery'}
                                      onChange={(e) =>
                                        setSelected(e.target.value)
                                      }
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="pickupDelivery"
                                    >
                                      Pickup and Delivery
                                    </label>
                                  </div>
                                )}
                                {mode === 3 && (
                                  <>
                                    <div className="form-check">
                                      <input
                                        className="form-check-input"
                                        type="radio"
                                        name="laundryService"
                                        id="dropOffCollectionBoth"
                                        value="drop_off_collection"
                                        checked={
                                          selected === 'drop_off_collection'
                                        }
                                        onChange={(e) =>
                                          setSelected(e.target.value)
                                        }
                                      />
                                      <label
                                        className="form-check-label"
                                        htmlFor="dropOffCollectionBoth"
                                      >
                                        Drop off and collection
                                      </label>
                                    </div>
                                    <div className="form-check">
                                      <input
                                        className="form-check-input"
                                        type="radio"
                                        name="laundryService"
                                        id="pickupDeliveryBoth"
                                        value="pickup_delivery"
                                        checked={selected === 'pickup_delivery'}
                                        onChange={(e) =>
                                          setSelected(e.target.value)
                                        }
                                      />
                                      <label
                                        className="form-check-label"
                                        htmlFor="pickupDeliveryBoth"
                                      >
                                        Pickup and Delivery
                                      </label>
                                    </div>
                                  </>
                                )}
                              </div>
                            </>
                          );
                        }

                        // Restaurant Service Mode (service_mode = 1, product type = food)
                        if (type === 'restaurant') {
                          return (
                            <div className="mb-3">
                              <h5>Restaurant Service</h5>
                              {(mode === 1 || mode === 4) && (
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    name="restaurantService"
                                    id="dineIn"
                                    value="dine_in"
                                    checked={selected === 'dine_in'}
                                    onChange={(e) =>
                                      setSelected(e.target.value)
                                    }
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="dineIn"
                                  >
                                    Dine In
                                  </label>
                                </div>
                              )}
                              {(mode === 2 || mode === 4) && (
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    name="restaurantService"
                                    id="takeaway"
                                    value="takeaway"
                                    checked={selected === 'takeaway'}
                                    onChange={(e) =>
                                      setSelected(e.target.value)
                                    }
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="takeaway"
                                  >
                                    Takeaway
                                  </label>
                                </div>
                              )}
                              {(mode === 3 || mode === 4) && (
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    name="restaurantService"
                                    id="deliveryRestaurant"
                                    value="delivery"
                                    checked={selected === 'delivery'}
                                    onChange={(e) =>
                                      setSelected(e.target.value)
                                    }
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="deliveryRestaurant"
                                  >
                                    Delivery
                                  </label>
                                </div>
                              )}
                            </div>
                          );
                        }

                        // Field Service Mode (service_mode = 1, product type = service)
                        if (type === 'field') {
                          return (
                            <div className="mb-3">
                              <h5>Field Service</h5>
                              {(mode === 1 || mode === 3) && (
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    name="fieldService"
                                    id="inStoreAppointment"
                                    value="in_store_appointment"
                                    checked={
                                      selected === 'in_store_appointment'
                                    }
                                    onChange={(e) =>
                                      setSelected(e.target.value)
                                    }
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="inStoreAppointment"
                                  >
                                    In Store Appointment
                                  </label>
                                </div>
                              )}
                              {(mode === 2 || mode === 3) && (
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    name="fieldService"
                                    id="onSiteAppointment"
                                    value="on_site_appointment"
                                    checked={selected === 'on_site_appointment'}
                                    onChange={(e) =>
                                      setSelected(e.target.value)
                                    }
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="onSiteAppointment"
                                  >
                                    On Site Appointment
                                  </label>
                                </div>
                              )}
                            </div>
                          );
                        }

                        return null;
                      })()}

                      {/* Service Type Selection - Only show if both services have costs */}
                      {shouldShowServiceTypeSelection() && (
                        <div className="mb-3">
                          <h5>Service Type</h5>
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="serviceType"
                              id="pickAndDrop"
                              value="pick_and_drop"
                              checked={serviceType === 'pick_and_drop'}
                              onChange={(e) => setServiceType(e.target.value)}
                            />
                            <label
                              className="form-check-label"
                              htmlFor="pickAndDrop"
                            >
                              Pick and Drop
                            </label>
                          </div>
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="serviceType"
                              id="delivery"
                              value="delivery"
                              checked={serviceType === 'delivery'}
                              onChange={(e) => setServiceType(e.target.value)}
                            />
                            <label
                              className="form-check-label"
                              htmlFor="delivery"
                            >
                              Delivery
                            </label>
                          </div>
                        </div>
                      )}

                      <div className="cs-option-amt-list">
                        <div className="cs-option-amt-left">Subtotal</div>
                        <div className="cs-option-amt-right">
                          {currencySymbol} {subtotal.toFixed(2)}
                        </div>
                      </div>
                      {shippingCostFromDeliveryApi > 0 && (
                        <div className="cs-option-amt-list">
                          <div className="cs-option-amt-left">
                            Delivery Charge
                          </div>
                          <div className="cs-option-amt-right">
                            {currencySymbol}{' '}
                            {shippingCostFromDeliveryApi.toFixed(2)}
                          </div>
                        </div>
                      )}

                      {/* Coupon Section */}
                      {coupons.length > 0 && (
                        <div className="mb-3 mt-3">
                          <div className="d-flex gap-2">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter coupon code"
                              value={couponCode}
                              onChange={(e) => {
                                setCouponCode(e.target.value);
                                setCouponError('');
                                if (selectedCoupon) {
                                  setSelectedCoupon(null);
                                }
                              }}
                              disabled={!!selectedCoupon || isApplyingCoupon}
                            />
                            {selectedCoupon ? (
                              <button
                                type="button"
                                className="btn btn-outline-danger"
                                onClick={handleRemoveCoupon}
                              >
                                Remove
                              </button>
                            ) : (
                              <button
                                type="button"
                                className="btn btn-primary"
                                onClick={handleApplyCoupon}
                                disabled={
                                  isApplyingCoupon || !couponCode.trim()
                                }
                              >
                                {isApplyingCoupon ? 'Applying...' : 'Apply'}
                              </button>
                            )}
                          </div>
                          {couponError && (
                            <small className="text-danger d-block mt-1">
                              {couponError}
                            </small>
                          )}
                          {selectedCoupon && (
                            <small className="text-success d-block mt-1">
                              Coupon "{selectedCoupon.code}" applied
                              successfully!
                            </small>
                          )}
                        </div>
                      )}

                      {/* Discount Display */}
                      {calculateDiscount > 0 && (
                        <div className="cs-option-amt-list text-success">
                          <div className="cs-option-amt-left">
                            Discount ({selectedDiscount?.name})
                          </div>
                          <div className="cs-option-amt-right">
                            (-) {currencySymbol} {calculateDiscount.toFixed(2)}
                          </div>
                        </div>
                      )}

                      {/* Coupon Discount Display */}
                      {calculateCouponDiscount > 0 && (
                        <div className="cs-option-amt-list text-success">
                          <div className="cs-option-amt-left">
                            Coupon ({selectedCoupon?.code})
                          </div>
                          <div className="cs-option-amt-right">
                            (-) {currencySymbol}{' '}
                            {calculateCouponDiscount.toFixed(2)}
                          </div>
                        </div>
                      )}

                      {/* Gift Card Section */}
                      {giftCards.length > 0 && (
                        <div className="mb-3 mt-3">
                          <div className="d-flex gap-2">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter gift card number"
                              value={giftCardCode}
                              onChange={(e) => {
                                setGiftCardCode(e.target.value);
                                setGiftCardError('');
                                if (selectedGiftCard) {
                                  setSelectedGiftCard(null);
                                }
                              }}
                              disabled={
                                !!selectedGiftCard || isApplyingGiftCard
                              }
                            />
                            {selectedGiftCard ? (
                              <button
                                type="button"
                                className="btn btn-outline-danger"
                                onClick={handleRemoveGiftCard}
                              >
                                Remove
                              </button>
                            ) : (
                              <button
                                type="button"
                                className="btn btn-primary"
                                onClick={handleApplyGiftCard}
                                disabled={
                                  isApplyingGiftCard || !giftCardCode.trim()
                                }
                              >
                                {isApplyingGiftCard ? 'Applying...' : 'Apply'}
                              </button>
                            )}
                          </div>
                          {giftCardError && (
                            <small className="text-danger d-block mt-1">
                              {giftCardError}
                            </small>
                          )}
                          {selectedGiftCard && (
                            <small className="text-success d-block mt-1">
                              Gift card "{selectedGiftCard.card_no}" applied
                              successfully!
                              {(() => {
                                const availableBalance =
                                  parseFloat(selectedGiftCard.amount) || 0;
                                return (
                                  <span
                                    className="d-block text-muted"
                                    style={{ fontSize: '0.85em' }}
                                  >
                                    Available balance: {currencySymbol}{' '}
                                    {availableBalance.toFixed(2)}
                                  </span>
                                );
                              })()}
                            </small>
                          )}
                        </div>
                      )}

                      {/* Gift Card Discount Display */}
                      {giftCardAmountToUse > 0 && (
                        <div className="cs-option-amt-list text-success">
                          <div className="cs-option-amt-left">
                            Gift Card ({selectedGiftCard?.card_no?.slice(-4)})
                          </div>
                          <div className="cs-option-amt-right">
                            (-) {currencySymbol}{' '}
                            {giftCardAmountToUse.toFixed(2)}
                          </div>
                        </div>
                      )}

                      {/* Gift Card Remaining Balance or Full Payment Message */}
                      {selectedGiftCard && giftCardAmountToUse > 0 && (
                        <div className="cs-option-amt-list text-info">
                          <div className="cs-option-amt-left">
                            <small>
                              {isGiftCardFullPayment ? (
                                <span className="text-success">
                                  Gift card covers full payment
                                </span>
                              ) : (
                                <>
                                  Remaining after gift card: {currencySymbol}{' '}
                                  {remainingAfterGiftCard.toFixed(2)}
                                  {(() => {
                                    const availableBalance =
                                      parseFloat(selectedGiftCard.amount) || 0;
                                    const remainingBalance =
                                      availableBalance - giftCardAmountToUse;
                                    if (remainingBalance > 0) {
                                      return (
                                        <span
                                          className="d-block text-muted"
                                          style={{ fontSize: '0.85em' }}
                                        >
                                          Gift card remaining balance:{' '}
                                          {currencySymbol}{' '}
                                          {remainingBalance.toFixed(2)}
                                        </span>
                                      );
                                    }
                                    return null;
                                  })()}
                                </>
                              )}
                            </small>
                          </div>
                          <div className="cs-option-amt-right">
                            {isGiftCardFullPayment ? (
                              <small className="text-success">
                                No payment required
                              </small>
                            ) : (
                              <small>Pay remaining amount</small>
                            )}
                          </div>
                        </div>
                      )}

                      {/* Show service cost based on conditional logic - only show if cost > 0 */}
                      {currentLocation &&
                        (() => {
                          const pickAndDropCost =
                            parseFloat(
                              String(currentLocation.shipping_cost || 0)
                            ) || 0;
                          const deliveryCost =
                            parseFloat(
                              String(currentLocation.delivery_cost || 0)
                            ) || 0;
                          const bothHaveCosts =
                            pickAndDropCost > 0 && deliveryCost > 0;

                          // Determine which cost to display
                          let displayCost = 0;
                          let displayLabel = '';

                          if (bothHaveCosts) {
                            // Both services have costs - show selected service cost
                            if (
                              serviceType === 'pick_and_drop' &&
                              pickAndDropCost > 0
                            ) {
                              displayCost = pickAndDropCost;
                              displayLabel = 'Pick and Drop Cost';
                            } else if (
                              serviceType === 'delivery' &&
                              deliveryCost > 0
                            ) {
                              displayCost = deliveryCost;
                              displayLabel = 'Delivery Cost';
                            }
                          } else {
                            // Only one service has cost - show automatic cost
                            const autoCost = getAutomaticServiceCost();
                            if (
                              autoCost &&
                              typeof autoCost.cost === 'number' &&
                              autoCost.cost > 0 &&
                              autoCost.type &&
                              autoCost.type.trim() !== ''
                            ) {
                              displayCost = autoCost.cost;
                              displayLabel = `${autoCost.type} Cost`;
                            }
                          }

                          // Only render if we have a valid cost > 0
                          if (displayCost > 0 && displayLabel) {
                            return (
                              <div className="cs-option-amt-list">
                                <div className="cs-option-amt-left">
                                  {displayLabel}
                                </div>
                                <div className="cs-option-amt-right">
                                  {currencySymbol} {displayCost.toFixed(2)}
                                </div>
                              </div>
                            );
                          }

                          return <></>;
                        })()}

                      {/* Minimum Order Amount Info */}
                      {(() => {
                        const finalPayable = total();
                        const hasDiscountOrCoupon =
                          calculateDiscount > 0 || calculateCouponDiscount > 0;
                        const isAtMinimum =
                          minimumOrderAmount > 0 &&
                          finalPayable === minimumOrderAmount;

                        // Show "Minimum order amount applied" when:
                        // 1. discountAffectsMinimum === 0 (minimum is enforced)
                        // 2. Discount or coupon is applied
                        // 3. Final payable equals minimum (discount/coupon was capped/ignored)
                        const showMinimumApplied =
                          discountAffectsMinimum === 0 &&
                          hasDiscountOrCoupon &&
                          isAtMinimum;

                        // Show "Add more to reach minimum" when:
                        // 1. Minimum order not met
                        // 2. There's a remaining amount to add
                        const showRemainingAmount =
                          minimumOrderAmount > 0 &&
                          !isMinimumOrderMet &&
                          parseFloat(String(remainingAmount)) > 0;

                        if (showMinimumApplied) {
                          return (
                            <div className="cs-option-amt-list text-info">
                              <div className="cs-option-amt-left">
                                <small>
                                  Minimum order amount applied
                                  {calculateCouponDiscount > 0 && (
                                    <span
                                      className="d-block text-muted"
                                      style={{ fontSize: '0.85em' }}
                                    >
                                      (Coupon discount adjusted to meet minimum)
                                    </span>
                                  )}
                                  {calculateDiscount > 0 &&
                                    calculateCouponDiscount === 0 && (
                                      <span
                                        className="d-block text-muted"
                                        style={{ fontSize: '0.85em' }}
                                      >
                                        (Discount adjusted to meet minimum)
                                      </span>
                                    )}
                                </small>
                              </div>
                              <div className="cs-option-amt-right">
                                <small>
                                  {currencySymbol}{' '}
                                  {minimumOrderAmount.toFixed(2)} minimum
                                </small>
                              </div>
                            </div>
                          );
                        } else if (showRemainingAmount) {
                          return (
                            <div className="cs-option-amt-list text-info">
                              <div className="cs-option-amt-left">
                                <small>Minimum order amount applied</small>
                              </div>
                              <div className="cs-option-amt-right">
                                <small>
                                  Add {currencySymbol} {remainingAmount} more to
                                  reach minimum
                                </small>
                              </div>
                            </div>
                          );
                        }
                        return null;
                      })()}

                      <div className="cs-option-amt-list cs-option-amt-listbg">
                        <div className="cs-option-amt-left">Amount Payable</div>
                        <div className="cs-option-amt-right">
                          <b>
                            {currencySymbol} {amountPayable.toFixed(2)}
                          </b>
                        </div>
                      </div>
                    </div>

                    {/* <div className="mb-3">
                      <h3>Service Type</h3>
                      {checkoutDetails?.delivery_required && (
                        
                      )}
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="serviceType"
                          id="pickupAndDelivery"
                          value="pickup_and_delivery"
                          defaultChecked
                        />
                        <label className="form-check-label" htmlFor="pickupAndDelivery">
                          Pickup and delivery
                        </label>
                      </div>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="serviceType"
                          id="deliveryOnly"
                          value="delivery_only"
                        />
                        <label className="form-check-label" htmlFor="deliveryOnly">
                          Delivery only
                        </label>
                      </div>
                    </div> */}

                    <div className="checkout-pay my-2">
                      <div className="mb-3">
                        <div className="form-check">
                          <Controller
                            name="agree_t_c"
                            control={billingFormControl}
                            render={({ field }) => (
                              <input
                                className="form-check-input"
                                type="checkbox"
                                {...field}
                                checked={billingFormGetValue('agree_t_c')}
                                value={String(billingFormGetValue('agree_t_c'))}
                                id="defaultCheck1"
                              />
                            )}
                          />

                          <label className="form-check-label">
                            I have read and agree to the website terms and
                            conditions <span className="text-danger">*</span>
                          </label>
                          {billingFormErrors.agree_t_c ? (
                            <small className="text-danger">
                              {billingFormErrors.agree_t_c?.message}
                            </small>
                          ) : null}
                        </div>
                      </div>

                      <div>
                        <div className="sec-hdr">
                          <h3>Payment Method</h3>
                        </div>
                        {isGiftCardFullPayment && (
                          <div className="alert alert-success mb-3">
                            <strong>Gift card covers full payment!</strong> No
                            additional payment method required.
                          </div>
                        )}
                        <div className="pstepsinner" id="step3">
                          <div className="user_cards">
                            <div>
                              {/* Gift Card Payment Option - Only show when gift card covers full payment */}
                              {isGiftCardFullPayment && (
                                <div className="payment_option payment_choose_option">
                                  <div className="payment-title">
                                    <div className="media-left flex-shrink-0 pe-0">
                                      <label className="container-blk">
                                        <input
                                          className="card-radio-select"
                                          name="paymentMethod"
                                          type="radio"
                                          value="gift_card"
                                          checked={
                                            paymentGateway === 'gift_card'
                                          }
                                          onChange={() =>
                                            setPaymentGateway('gift_card')
                                          }
                                        />
                                        <span className="checkmark"></span>
                                        <span className="ms-2">
                                          Gift Card Payment
                                        </span>
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              )}

                              {Number(checkoutDetails?.is_cod) === 1 && (
                                <div className="payment_option payment_choose_option">
                                  <div className="payment-title">
                                    <div className="media-left flex-shrink-0 pe-0">
                                      <label className="container-blk">
                                        <input
                                          className="card-radio-select"
                                          name="paymentMethod"
                                          type="radio"
                                          value="cod"
                                          checked={paymentGateway === 'cod'}
                                          onChange={() =>
                                            setPaymentGateway('cod')
                                          }
                                          disabled={isGiftCardFullPayment}
                                        />
                                        <span className="checkmark"></span>
                                        <span className="ms-2">
                                          {hostname === 'laundry-lounge.co.uk'
                                            ? 'Cash On Arrival'
                                            : 'Cash on Delivery'}
                                          {isGiftCardFullPayment &&
                                            ' (Not required - Gift card covers full payment)'}
                                        </span>
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              )}
                              {(cartItems.length > 0 || state?.quick) &&
                                gateways?.map((gateway) => (
                                  <div
                                    key={gateway?.name}
                                    className="payment_option payment_choose_option"
                                  >
                                    <div className="payment-title">
                                      <div className="media-left flex-shrink-0 pe-0">
                                        <label className="container-blk">
                                          <input
                                            className="card-radio-select"
                                            name="paymentMethod"
                                            type="radio"
                                            value={gateway?.name}
                                            checked={
                                              paymentGateway === gateway?.name
                                            }
                                            onChange={() => {
                                              setPaymentGateway(gateway?.name);
                                              // Reset card selection when switching payment methods
                                              if (
                                                gateway?.name.toLowerCase() !==
                                                'stripe'
                                              ) {
                                                setSelectedCard(null);
                                                setUseNewCard(false);
                                              }
                                            }}
                                            disabled={isGiftCardFullPayment}
                                          />
                                          <span className="checkmark"></span>
                                          <span className="ms-2">
                                            {hostname ===
                                              'laundry-lounge.co.uk' &&
                                            gateway?.name.toLowerCase() ===
                                              'stripe'
                                              ? 'Card'
                                              : gateway?.name}

                                            {isGiftCardFullPayment &&
                                              ' (Not required - Gift card covers full payment)'}
                                          </span>
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                ))}

                              {/* Saved Cards UI for Stripe */}
                              {paymentGateway.toLowerCase() === 'stripe' && (
                                <div className="mt-4 mb-3">
                                  <h5 className="mb-3">
                                    Saved Payment Methods
                                  </h5>
                                  {loadingSavedCards ? (
                                    <div className="d-flex justify-content-center align-items-center p-4">
                                      <div
                                        className="spinner-border spinner-border-sm text-primary"
                                        role="status"
                                      >
                                        <span className="visually-hidden">
                                          Loading...
                                        </span>
                                      </div>
                                      <span className="ms-2 text-muted">
                                        Loading saved cards...
                                      </span>
                                    </div>
                                  ) : savedCards.length > 0 ? (
                                    <div className="saved-cards-container">
                                      {savedCards.map((card) => (
                                        <div
                                          key={card.id}
                                          className={`saved-card-item mb-3 p-3 border rounded ${
                                            selectedCard?.id === card.id &&
                                            !useNewCard
                                              ? 'border-primary bg-light'
                                              : 'border-secondary'
                                          }`}
                                          style={{
                                            cursor: 'pointer',
                                            transition: 'all 0.3s ease',
                                          }}
                                          onClick={() => {
                                            setSelectedCard(card);
                                            setUseNewCard(false);
                                          }}
                                        >
                                          <div className="d-flex align-items-center justify-content-between">
                                            <div className="d-flex align-items-center">
                                              <input
                                                type="radio"
                                                name="savedCard"
                                                checked={
                                                  selectedCard?.id ===
                                                    card.id && !useNewCard
                                                }
                                                onChange={() => {
                                                  setSelectedCard(card);
                                                  setUseNewCard(false);
                                                }}
                                                className="me-3"
                                              />
                                              <div>
                                                <div className="fw-bold">
                                                  {card.brand
                                                    ? card.brand.toUpperCase()
                                                    : 'CARD'}{' '}
                                                  •••• {card.last4}
                                                </div>
                                                {card.name && (
                                                  <div className="text-muted small">
                                                    {card.name}
                                                  </div>
                                                )}
                                              </div>
                                            </div>
                                            {selectedCard?.id === card.id &&
                                              !useNewCard && (
                                                <span className="text-primary">
                                                  ✓ Selected
                                                </span>
                                              )}
                                          </div>
                                        </div>
                                      ))}

                                      {/* Option to use new card */}
                                      <div
                                        className={`saved-card-item mb-3 p-3 border rounded ${
                                          useNewCard
                                            ? 'border-primary bg-light'
                                            : 'border-secondary'
                                        }`}
                                        style={{
                                          cursor: 'pointer',
                                          transition: 'all 0.3s ease',
                                        }}
                                        onClick={() => {
                                          setUseNewCard(true);
                                          setSelectedCard(null);
                                        }}
                                      >
                                        <div className="d-flex align-items-center">
                                          <input
                                            type="radio"
                                            name="savedCard"
                                            checked={useNewCard}
                                            onChange={() => {
                                              setUseNewCard(true);
                                              setSelectedCard(null);
                                            }}
                                            className="me-3"
                                          />
                                          <div className="fw-bold">
                                            Use a new card
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  ) : (
                                    <div className="mt-3 mb-3 p-3 bg-light border rounded">
                                      <p className="mb-0 text-muted">
                                        No saved payment methods. You'll be able
                                        to save your card after this payment.
                                      </p>
                                    </div>
                                  )}
                                </div>
                              )}
                              {/* {gateways?.map((gateway) => (
                                <div className="payment_option payment_choose_option">
                                  <div className="payment-title">
                                    <div className="media-left flex-shrink-0 pe-0">
                                      <label className="container-blk">
                                        <input
                                          className="card-radio-select"
                                          name="paymentMethod"
                                          type="radio"
                                          value={gateway?.name}
                                          checked={
                                            paymentGateway === gateway?.name
                                          }
                                          onChange={() =>
                                            setPaymentGateway(gateway?.name)
                                          }
                                        />
                                        <span className="checkmark"></span>
                                        <span className="ms-2">
                                          {gateway?.name}
                                        </span>
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              ))} */}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="mb-12">
                        <button
                          type="submit"
                          className="hover-btn primary-btn text-white w-100"
                          disabled={isPlacingOrder || _isLoading}
                        >
                          {isPlacingOrder ? (
                            <>
                              <span
                                className="spinner-border spinner-border-sm me-2"
                                role="status"
                                aria-hidden="true"
                              ></span>
                              Placing Order...
                            </>
                          ) : (
                            'Place Order'
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
          {stripePromise && checkoutDetails && (
            <StripeModal
              isOpen={isModalOpen}
              onClose={() => {
                setIsModalOpen(false);
                setSetupIntentClientSecret(null);
                // Only reset isPlacingOrder if it's not a success flow
                // (i.e., user cancelled the modal)
                if (!isStripeSuccessRef.current) {
                  setIsPlacingOrder(false); // Re-enable button if modal is closed/cancelled
                }
                // Reset the ref for next time
                isStripeSuccessRef.current = false;
              }}
              amount={total()}
              stripePromise={stripePromise}
              transactionId={`txn_${Date.now()}`}
              setupIntentClientSecret={setupIntentClientSecret}
              onSuccess={(stripeData) => {
                const generatedTransactionId = `txn_${Date.now()}`; // simple timestamp-based ID

                // Mark as success so onClose doesn't reset isPlacingOrder
                // Using ref for synchronous access since StripeModal calls onClose immediately after
                isStripeSuccessRef.current = true;

                // Keep isPlacingOrder true as we're now proceeding with order placement
                // The loader will stay visible during the API call
                // Note: StripeModal will call onClose() after this, but we've set the ref to prevent resetting isPlacingOrder
                onHandlePaymentConfirmation(generatedTransactionId, {
                  ...stripeDetails,
                  stripeToken:
                    stripeData.token?.id || stripeData.paymentMethod?.id, // from Stripe token or payment method response
                  paymentMethodId: stripeData.paymentMethod?.id,
                  setupIntentId: stripeData.setupIntent?.id,
                });
              }}
            />
          )}
          {checkoutDetails && (
            <PayPalModal
              isOpen={isPaypalModalOpen}
              onClose={() => setIsPaypalModalOpen(false)}
              amount={total()}
              paypalKey={
                checkoutDetails?.gateways?.find(
                  (gateway) => gateway?.name === 'PayPal'
                )?.key
              }
              currency={currencyCode}
              billingAddress={paypalDetails?.billingAddress}
              onSuccess={(paypalData) => {
                onHandlePaymentConfirmation(
                  paypalData.transactionId,
                  paypalDetails
                );
                // onHandlePaymentConfirmation(paypalData.transactionId, {
                //   ...paypalDetails, // same billing/shipping data format
                // });
              }}
            />
          )}
        </>
      )}
      {/* React Hook Form DevTools - Only shows in development */}
      {process.env.NODE_ENV === 'development' && (
        <DevTool control={billingFormControl} />
      )}
    </>
  );
}
